/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener
 * crm-screener
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {
    type BulkUpdateLeadSOffenderRecordsRequest,
    BulkUpdateLeadSOffenderRecordsRequestFromJSON,
    BulkUpdateLeadSOffenderRecordsRequestToJSON,
} from '../models/BulkUpdateLeadSOffenderRecordsRequest';
import {
    type BulkUpdateSourceContactTagsRequest,
    BulkUpdateSourceContactTagsRequestFromJSON,
    BulkUpdateSourceContactTagsRequestToJSON,
} from '../models/BulkUpdateSourceContactTagsRequest';
import {
    type CreateAssignmentRule201Response,
    CreateAssignmentRule201ResponseFromJSON,
    CreateAssignmentRule201ResponseToJSON,
} from '../models/CreateAssignmentRule201Response';
import {
    type CreateAssignmentRuleRequest,
    CreateAssignmentRuleRequestFromJSON,
    CreateAssignmentRuleRequestToJSON,
} from '../models/CreateAssignmentRuleRequest';
import {
    type CreateDocumentForLead201Response,
    CreateDocumentForLead201ResponseFromJSON,
    CreateDocumentForLead201ResponseToJSON,
} from '../models/CreateDocumentForLead201Response';
import {
    type CreateIntakeIntegration200Response,
    CreateIntakeIntegration200ResponseFromJSON,
    CreateIntakeIntegration200ResponseToJSON,
} from '../models/CreateIntakeIntegration200Response';
import {
    type CreateLead201Response,
    CreateLead201ResponseFromJSON,
    CreateLead201ResponseToJSON,
} from '../models/CreateLead201Response';
import {
    type CreateLeadAssignment200Response,
    CreateLeadAssignment200ResponseFromJSON,
    CreateLeadAssignment200ResponseToJSON,
} from '../models/CreateLeadAssignment200Response';
import {
    type CreateLeadAssignmentRequest,
    CreateLeadAssignmentRequestFromJSON,
    CreateLeadAssignmentRequestToJSON,
} from '../models/CreateLeadAssignmentRequest';
import {
    type CreateLeadComment201Response,
    CreateLeadComment201ResponseFromJSON,
    CreateLeadComment201ResponseToJSON,
} from '../models/CreateLeadComment201Response';
import {
    type CreateLeadRequest,
    CreateLeadRequestFromJSON,
    CreateLeadRequestToJSON,
} from '../models/CreateLeadRequest';
import {
    type CreateOrDeleteLeadCommentReaction200Response,
    CreateOrDeleteLeadCommentReaction200ResponseFromJSON,
    CreateOrDeleteLeadCommentReaction200ResponseToJSON,
} from '../models/CreateOrDeleteLeadCommentReaction200Response';
import {
    type CreateOrDeleteLeadCommentReactionRequest,
    CreateOrDeleteLeadCommentReactionRequestFromJSON,
    CreateOrDeleteLeadCommentReactionRequestToJSON,
} from '../models/CreateOrDeleteLeadCommentReactionRequest';
import {
    type CreatePccPatient201Response,
    CreatePccPatient201ResponseFromJSON,
    CreatePccPatient201ResponseToJSON,
} from '../models/CreatePccPatient201Response';
import {
    type CreatePccPatientRequest,
    CreatePccPatientRequestFromJSON,
    CreatePccPatientRequestToJSON,
} from '../models/CreatePccPatientRequest';
import {
    type CreateSource201Response,
    CreateSource201ResponseFromJSON,
    CreateSource201ResponseToJSON,
} from '../models/CreateSource201Response';
import {
    type CreateSourceContact201Response,
    CreateSourceContact201ResponseFromJSON,
    CreateSourceContact201ResponseToJSON,
} from '../models/CreateSourceContact201Response';
import {
    type CreateSourceContactTag201Response,
    CreateSourceContactTag201ResponseFromJSON,
    CreateSourceContactTag201ResponseToJSON,
} from '../models/CreateSourceContactTag201Response';
import {
    type DeleteLeadAssignment200Response,
    DeleteLeadAssignment200ResponseFromJSON,
    DeleteLeadAssignment200ResponseToJSON,
} from '../models/DeleteLeadAssignment200Response';
import {
    type Document,
    DocumentFromJSON,
    DocumentToJSON,
} from '../models/Document';
import {
    type FindAdmissionStatusOptions200Response,
    FindAdmissionStatusOptions200ResponseFromJSON,
    FindAdmissionStatusOptions200ResponseToJSON,
} from '../models/FindAdmissionStatusOptions200Response';
import {
    type FindAdmissionStatusOptionsRequest,
    FindAdmissionStatusOptionsRequestFromJSON,
    FindAdmissionStatusOptionsRequestToJSON,
} from '../models/FindAdmissionStatusOptionsRequest';
import {
    type FindAllCommentsForLead200Response,
    FindAllCommentsForLead200ResponseFromJSON,
    FindAllCommentsForLead200ResponseToJSON,
} from '../models/FindAllCommentsForLead200Response';
import {
    type FindAllIntegrationsByFacilityId200Response,
    FindAllIntegrationsByFacilityId200ResponseFromJSON,
    FindAllIntegrationsByFacilityId200ResponseToJSON,
} from '../models/FindAllIntegrationsByFacilityId200Response';
import {
    type FindAllLeadCalendarEvents200Response,
    FindAllLeadCalendarEvents200ResponseFromJSON,
    FindAllLeadCalendarEvents200ResponseToJSON,
} from '../models/FindAllLeadCalendarEvents200Response';
import {
    type FindAllLeadStatuses200Response,
    FindAllLeadStatuses200ResponseFromJSON,
    FindAllLeadStatuses200ResponseToJSON,
} from '../models/FindAllLeadStatuses200Response';
import {
    type FindAllLeads200Response,
    FindAllLeads200ResponseFromJSON,
    FindAllLeads200ResponseToJSON,
} from '../models/FindAllLeads200Response';
import {
    type FindAllPalIntegrationsByFacilityId200Response,
    FindAllPalIntegrationsByFacilityId200ResponseFromJSON,
    FindAllPalIntegrationsByFacilityId200ResponseToJSON,
} from '../models/FindAllPalIntegrationsByFacilityId200Response';
import {
    type FindAllScreenerSources200Response,
    FindAllScreenerSources200ResponseFromJSON,
    FindAllScreenerSources200ResponseToJSON,
} from '../models/FindAllScreenerSources200Response';
import {
    type FindAllScreenerSourcesRequest,
    FindAllScreenerSourcesRequestFromJSON,
    FindAllScreenerSourcesRequestToJSON,
} from '../models/FindAllScreenerSourcesRequest';
import {
    type FindAllSourceContactTags200Response,
    FindAllSourceContactTags200ResponseFromJSON,
    FindAllSourceContactTags200ResponseToJSON,
} from '../models/FindAllSourceContactTags200Response';
import {
    type FindAllSourceContacts200Response,
    FindAllSourceContacts200ResponseFromJSON,
    FindAllSourceContacts200ResponseToJSON,
} from '../models/FindAllSourceContacts200Response';
import {
    type FindAllSpecialCriteria200Response,
    FindAllSpecialCriteria200ResponseFromJSON,
    FindAllSpecialCriteria200ResponseToJSON,
} from '../models/FindAllSpecialCriteria200Response';
import {
    type FindHospitalizedInstances200Response,
    FindHospitalizedInstances200ResponseFromJSON,
    FindHospitalizedInstances200ResponseToJSON,
} from '../models/FindHospitalizedInstances200Response';
import {
    type FindLeadsBatchWithCommentCounts200Response,
    FindLeadsBatchWithCommentCounts200ResponseFromJSON,
    FindLeadsBatchWithCommentCounts200ResponseToJSON,
} from '../models/FindLeadsBatchWithCommentCounts200Response';
import {
    type FindLeadsBatchWithCommentCountsRequest,
    FindLeadsBatchWithCommentCountsRequestFromJSON,
    FindLeadsBatchWithCommentCountsRequestToJSON,
} from '../models/FindLeadsBatchWithCommentCountsRequest';
import {
    type FindLeadsBatchWithDocumentStats200Response,
    FindLeadsBatchWithDocumentStats200ResponseFromJSON,
    FindLeadsBatchWithDocumentStats200ResponseToJSON,
} from '../models/FindLeadsBatchWithDocumentStats200Response';
import {
    type FindLeadsBatchWithDocumentStatsRequest,
    FindLeadsBatchWithDocumentStatsRequestFromJSON,
    FindLeadsBatchWithDocumentStatsRequestToJSON,
} from '../models/FindLeadsBatchWithDocumentStatsRequest';
import {
    type FindMedicationsForLead200Response,
    FindMedicationsForLead200ResponseFromJSON,
    FindMedicationsForLead200ResponseToJSON,
} from '../models/FindMedicationsForLead200Response';
import {
    type FindOneExecutionsAvailableByFacilityId200Response,
    FindOneExecutionsAvailableByFacilityId200ResponseFromJSON,
    FindOneExecutionsAvailableByFacilityId200ResponseToJSON,
} from '../models/FindOneExecutionsAvailableByFacilityId200Response';
import {
    type FindOneIntegrationSettingsByFacilityId200Response,
    FindOneIntegrationSettingsByFacilityId200ResponseFromJSON,
    FindOneIntegrationSettingsByFacilityId200ResponseToJSON,
} from '../models/FindOneIntegrationSettingsByFacilityId200Response';
import {
    type FindOnePccAdvancedPatientDetails200Response,
    FindOnePccAdvancedPatientDetails200ResponseFromJSON,
    FindOnePccAdvancedPatientDetails200ResponseToJSON,
} from '../models/FindOnePccAdvancedPatientDetails200Response';
import {
    type FindOnePccPatient200Response,
    FindOnePccPatient200ResponseFromJSON,
    FindOnePccPatient200ResponseToJSON,
} from '../models/FindOnePccPatient200Response';
import {
    type FindOnePccPendingPatient200Response,
    FindOnePccPendingPatient200ResponseFromJSON,
    FindOnePccPendingPatient200ResponseToJSON,
} from '../models/FindOnePccPendingPatient200Response';
import {
    type FindSOffenderRecordsForLead200Response,
    FindSOffenderRecordsForLead200ResponseFromJSON,
    FindSOffenderRecordsForLead200ResponseToJSON,
} from '../models/FindSOffenderRecordsForLead200Response';
import {
    type GenerateReport200Response,
    GenerateReport200ResponseFromJSON,
    GenerateReport200ResponseToJSON,
} from '../models/GenerateReport200Response';
import {
    type GenerateSOffenderRecordsReport200Response,
    GenerateSOffenderRecordsReport200ResponseFromJSON,
    GenerateSOffenderRecordsReport200ResponseToJSON,
} from '../models/GenerateSOffenderRecordsReport200Response';
import {
    type GetPccDemographicsPrefill200Response,
    GetPccDemographicsPrefill200ResponseFromJSON,
    GetPccDemographicsPrefill200ResponseToJSON,
} from '../models/GetPccDemographicsPrefill200Response';
import {
    type GetPccPicklist200Response,
    GetPccPicklist200ResponseFromJSON,
    GetPccPicklist200ResponseToJSON,
} from '../models/GetPccPicklist200Response';
import {
    type IntegrationCredentials,
    IntegrationCredentialsFromJSON,
    IntegrationCredentialsToJSON,
} from '../models/IntegrationCredentials';
import {
    type IntegrationSettings,
    IntegrationSettingsFromJSON,
    IntegrationSettingsToJSON,
} from '../models/IntegrationSettings';
import {
    type Lead,
    LeadFromJSON,
    LeadToJSON,
} from '../models/Lead';
import {
    type LeadComment,
    LeadCommentFromJSON,
    LeadCommentToJSON,
} from '../models/LeadComment';
import {
    type ListAssignmentRules200Response,
    ListAssignmentRules200ResponseFromJSON,
    ListAssignmentRules200ResponseToJSON,
} from '../models/ListAssignmentRules200Response';
import {
    type ListGeneratedReports200Response,
    ListGeneratedReports200ResponseFromJSON,
    ListGeneratedReports200ResponseToJSON,
} from '../models/ListGeneratedReports200Response';
import {
    type PatchPccDemographics200Response,
    PatchPccDemographics200ResponseFromJSON,
    PatchPccDemographics200ResponseToJSON,
} from '../models/PatchPccDemographics200Response';
import {
    type PatchPccDemographicsRequest,
    PatchPccDemographicsRequestFromJSON,
    PatchPccDemographicsRequestToJSON,
} from '../models/PatchPccDemographicsRequest';
import {
    type PccAdvancedPatientDetails,
    PccAdvancedPatientDetailsFromJSON,
    PccAdvancedPatientDetailsToJSON,
} from '../models/PccAdvancedPatientDetails';
import {
    type ReadmitToFacility200Response,
    ReadmitToFacility200ResponseFromJSON,
    ReadmitToFacility200ResponseToJSON,
} from '../models/ReadmitToFacility200Response';
import {
    type ReadmitToFacilityRequest,
    ReadmitToFacilityRequestFromJSON,
    ReadmitToFacilityRequestToJSON,
} from '../models/ReadmitToFacilityRequest';
import {
    type ReorderAssignmentRulesRequest,
    ReorderAssignmentRulesRequestFromJSON,
    ReorderAssignmentRulesRequestToJSON,
} from '../models/ReorderAssignmentRulesRequest';
import {
    type ReturnToFacilityRequest,
    ReturnToFacilityRequestFromJSON,
    ReturnToFacilityRequestToJSON,
} from '../models/ReturnToFacilityRequest';
import {
    type RevertAdmissionStatusRequest,
    RevertAdmissionStatusRequestFromJSON,
    RevertAdmissionStatusRequestToJSON,
} from '../models/RevertAdmissionStatusRequest';
import {
    type ScreenerGeneratedDocumentType,
    ScreenerGeneratedDocumentTypeFromJSON,
    ScreenerGeneratedDocumentTypeToJSON,
} from '../models/ScreenerGeneratedDocumentType';
import {
    type SetLeadAssignments200Response,
    SetLeadAssignments200ResponseFromJSON,
    SetLeadAssignments200ResponseToJSON,
} from '../models/SetLeadAssignments200Response';
import {
    type SetLeadAssignmentsRequest,
    SetLeadAssignmentsRequestFromJSON,
    SetLeadAssignmentsRequestToJSON,
} from '../models/SetLeadAssignmentsRequest';
import {
    type Source,
    SourceFromJSON,
    SourceToJSON,
} from '../models/Source';
import {
    type SourceConflictErrorResponse,
    SourceConflictErrorResponseFromJSON,
    SourceConflictErrorResponseToJSON,
} from '../models/SourceConflictErrorResponse';
import {
    type SourceContact,
    SourceContactFromJSON,
    SourceContactToJSON,
} from '../models/SourceContact';
import {
    type SourceContactTag,
    SourceContactTagFromJSON,
    SourceContactTagToJSON,
} from '../models/SourceContactTag';
import {
    type SyncLeadSOffenderRecordsByIdRequest,
    SyncLeadSOffenderRecordsByIdRequestFromJSON,
    SyncLeadSOffenderRecordsByIdRequestToJSON,
} from '../models/SyncLeadSOffenderRecordsByIdRequest';
import {
    type UpdateAdmissionStatusById400Response,
    UpdateAdmissionStatusById400ResponseFromJSON,
    UpdateAdmissionStatusById400ResponseToJSON,
} from '../models/UpdateAdmissionStatusById400Response';
import {
    type UpdateAdmissionStatusRequest,
    UpdateAdmissionStatusRequestFromJSON,
    UpdateAdmissionStatusRequestToJSON,
} from '../models/UpdateAdmissionStatusRequest';
import {
    type UpdateAssignmentRuleRequest,
    UpdateAssignmentRuleRequestFromJSON,
    UpdateAssignmentRuleRequestToJSON,
} from '../models/UpdateAssignmentRuleRequest';
import {
    type UpdateLeadAssignmentRequest,
    UpdateLeadAssignmentRequestFromJSON,
    UpdateLeadAssignmentRequestToJSON,
} from '../models/UpdateLeadAssignmentRequest';
import {
    type UpdateLeadDecisionRequest,
    UpdateLeadDecisionRequestFromJSON,
    UpdateLeadDecisionRequestToJSON,
} from '../models/UpdateLeadDecisionRequest';
import {
    type UpdateLeadSOffenderRecordById200Response,
    UpdateLeadSOffenderRecordById200ResponseFromJSON,
    UpdateLeadSOffenderRecordById200ResponseToJSON,
} from '../models/UpdateLeadSOffenderRecordById200Response';
import {
    type UpdateLeadSOffenderRecordRequest,
    UpdateLeadSOffenderRecordRequestFromJSON,
    UpdateLeadSOffenderRecordRequestToJSON,
} from '../models/UpdateLeadSOffenderRecordRequest';
import {
    type UpdatePreviousStayRequest,
    UpdatePreviousStayRequestFromJSON,
    UpdatePreviousStayRequestToJSON,
} from '../models/UpdatePreviousStayRequest';
import {
    type UpdateSpecialCriteriaById200Response,
    UpdateSpecialCriteriaById200ResponseFromJSON,
    UpdateSpecialCriteriaById200ResponseToJSON,
} from '../models/UpdateSpecialCriteriaById200Response';
import {
    type UpdateSpecialCriteriaByIdRequest,
    UpdateSpecialCriteriaByIdRequestFromJSON,
    UpdateSpecialCriteriaByIdRequestToJSON,
} from '../models/UpdateSpecialCriteriaByIdRequest';
import {
    type UploadPccAdvancedPatientDetails200Response,
    UploadPccAdvancedPatientDetails200ResponseFromJSON,
    UploadPccAdvancedPatientDetails200ResponseToJSON,
} from '../models/UploadPccAdvancedPatientDetails200Response';
import {
    type UploadPccPatientDetails200Response,
    UploadPccPatientDetails200ResponseFromJSON,
    UploadPccPatientDetails200ResponseToJSON,
} from '../models/UploadPccPatientDetails200Response';
import {
    type UploadPccPatientDetailsRequest,
    UploadPccPatientDetailsRequestFromJSON,
    UploadPccPatientDetailsRequestToJSON,
} from '../models/UploadPccPatientDetailsRequest';

export interface BulkUpdateLeadSOffenderRecordsOperationRequest {
    /**
     * 
     */
    leadId: string;
    /**
     * 
     */
    bulkUpdateLeadSOffenderRecordsRequest: BulkUpdateLeadSOffenderRecordsRequest;
}

export interface BulkUpdateSourceContactTagsOperationRequest {
    /**
     * 
     */
    bulkUpdateSourceContactTagsRequest: BulkUpdateSourceContactTagsRequest;
}

export interface CancelLeadByIdRequest {
    /**
     * 
     */
    leadId: string;
}

export interface ClaimLeadByIdRequest {
    /**
     * 
     */
    leadId: string;
}

export interface CreateAssignmentRuleOperationRequest {
    /**
     * 
     */
    createAssignmentRuleRequest: CreateAssignmentRuleRequest;
}

export interface CreateDocumentForLeadRequest {
    /**
     * 
     */
    leadId: string;
    /**
     * 
     */
    document: Document;
}

export interface CreateIntakeIntegrationRequest {
    /**
     * 
     */
    facilityId: string;
    /**
     * 
     */
    integrationCredentials: Omit<IntegrationCredentials, 'facility_id'>;
}

export interface CreateLeadOperationRequest {
    /**
     * 
     */
    createLeadRequest: CreateLeadRequest;
}

export interface CreateLeadAssignmentOperationRequest {
    /**
     * 
     */
    leadId: string;
    /**
     * 
     */
    createLeadAssignmentRequest: CreateLeadAssignmentRequest;
}

export interface CreateLeadCommentRequest {
    /**
     * 
     */
    leadId: string;
    /**
     * 
     */
    leadComment: LeadComment;
}

export interface CreateOrDeleteLeadCommentReactionOperationRequest {
    /**
     * 
     */
    commentId: string;
    /**
     * 
     */
    createOrDeleteLeadCommentReactionRequest: CreateOrDeleteLeadCommentReactionRequest;
}

export interface CreatePccPatientOperationRequest {
    /**
     * 
     */
    leadId: string;
    /**
     * 
     */
    createPccPatientRequest: CreatePccPatientRequest;
}

export interface CreateSourceRequest {
    /**
     * 
     */
    source: Omit<Source, 'merged_into'|'is_deleted'|'merged_into_source'>;
}

export interface CreateSourceContactRequest {
    /**
     * 
     */
    sourceContact: SourceContact;
}

export interface CreateSourceContactTagRequest {
    /**
     * 
     */
    sourceContactTag: SourceContactTag;
}

export interface DeleteAssignmentRuleRequest {
    /**
     * 
     */
    ruleId: string;
}

export interface DeleteDocumentForLeadRequest {
    /**
     * 
     */
    leadId: string;
    /**
     * 
     */
    documentId: string;
}

export interface DeleteLeadAssignmentRequest {
    /**
     * 
     */
    leadId: string;
    /**
     * 
     */
    assignmentId: string;
}

export interface DeleteLeadByIdRequest {
    /**
     * 
     */
    leadId: string;
}

export interface DeleteLeadCommentByIdRequest {
    /**
     * 
     */
    commentId: string;
}

export interface DeleteSourceByIdRequest {
    /**
     * 
     */
    sourceId: string;
}

export interface DeleteSourceContactByIdRequest {
    /**
     * 
     */
    contactId: string;
}

export interface DeleteSourceContactTagByIdRequest {
    /**
     * 
     */
    tagId: string;
}

export interface EvaluateLeadByIdRequest {
    /**
     * 
     */
    leadId: string;
}

export interface FindAdmissionStatusOptionsOperationRequest {
    /**
     * 
     */
    findAdmissionStatusOptionsRequest: FindAdmissionStatusOptionsRequest;
}

export interface FindAllCommentsForLeadRequest {
    /**
     * 
     */
    leadId: string;
}

export interface FindAllIntegrationsByFacilityIdRequest {
    /**
     * 
     */
    facilityId: string;
}

export interface FindAllLeadCalendarEventsRequest {
    /**
     * 
     */
    startDate: Date;
    /**
     * 
     */
    endDate: Date;
    /**
     * 
     */
    facilityId?: string;
    /**
     * Comma-delimited list of event types to include. Omit to include all.
     */
    eventTypes?: string;
    /**
     * 
     */
    includeCancelled?: boolean;
}

export interface FindAllLeadsRequest {
    /**
     * 
     */
    facilityId?: string;
    /**
     * 
     */
    sourceId?: string;
    /**
     * 
     */
    search?: string;
    /**
     * 
     */
    limit?: number;
    /**
     * 
     */
    page?: number;
    /**
     * 
     */
    suggestion?: string;
    /**
     * 
     */
    includeCancelled?: boolean;
    /**
     * 
     */
    includeOtherFacilityDuplicates?: boolean;
    /**
     * 
     */
    connector?: string;
    /**
     * 
     */
    admissionStatus?: string;
    /**
     * 
     */
    payerType?: string;
    /**
     * 
     * @deprecated
     */
    payer?: string;
    /**
     * 
     */
    payerSource?: string;
    /**
     * 
     */
    includeNullPayerType?: boolean;
    /**
     * 
     */
    includeNullPayerSource?: boolean;
    /**
     * Comma-delimited list of network status values (in_network, out_of_network, undetermined)
     */
    networkStatus?: string;
    /**
     * 
     */
    pccStatus?: string;
    /**
     * 
     */
    matrixCareStatus?: string;
    /**
     * 
     */
    statusId?: string;
    /**
     * Filters current Yes, Accept leads as automated when the AI auto-accept marker is present and manual when it is absent. Manual can include non-AI system paths.
     */
    reviewStageAcceptSource?: FindAllLeadsReviewStageAcceptSourceEnum;
    /**
     * 
     */
    includeEmptyAdmission?: boolean;
    /**
     * 
     */
    hasNewHospitalMessages?: boolean;
    /**
     * 
     */
    hasNewDocuments?: boolean;
    /**
     * Comma-separated user IDs. Filter to leads with at least one active assignment for any of these users.
     */
    assigneeUserIds?: string;
    /**
     * When true, filter to leads with no active assignments.
     */
    unassigned?: boolean;
    /**
     * Comma-separated referral care attribute IDs in the clinical_care_need category. Filter to leads with at least one of them applied. Include the value `none` to also match leads with no clinical_care_need applied.
     */
    clinicalCareNeeds?: string;
    /**
     * Comma-separated referral care attribute IDs in the program category. Filter to leads with at least one of them applied. Include the value `none` to also match leads with no program applied.
     */
    programs?: string;
    /**
     * Comma-separated referral care attribute IDs in the type_of_care category. Filter to leads with at least one of them applied. Include the value `none` to also match leads with no type_of_care applied.
     */
    typesOfCare?: string;
}

export interface FindAllPalIntegrationsByFacilityIdRequest {
    /**
     * 
     */
    facilityId: string;
}

export interface FindAllScreenerSourcesOperationRequest {
    /**
     * 
     */
    findAllScreenerSourcesRequest: FindAllScreenerSourcesRequest;
}

export interface FindAllSourceContactsRequest {
    /**
     * 
     */
    sourceId?: string;
    /**
     * 
     */
    search?: string;
    /**
     * 
     */
    limit?: number;
    /**
     * 
     */
    page?: number;
}

export interface FindAllSpecialCriteriaRequest {
    /**
     * 
     */
    facilityId: string;
    /**
     * 
     */
    informational?: boolean;
}

export interface FindHospitalizedInstancesRequest {
    /**
     * 
     */
    leadId: string;
}

export interface FindLeadByIdRequest {
    /**
     * 
     */
    leadId: string;
}

export interface FindLeadsBatchWithCommentCountsOperationRequest {
    /**
     * 
     */
    findLeadsBatchWithCommentCountsRequest: FindLeadsBatchWithCommentCountsRequest;
}

export interface FindLeadsBatchWithDocumentStatsOperationRequest {
    /**
     * 
     */
    findLeadsBatchWithDocumentStatsRequest: FindLeadsBatchWithDocumentStatsRequest;
}

export interface FindMedicationsForLeadRequest {
    /**
     * 
     */
    leadId: string;
}

export interface FindOneExecutionsAvailableByFacilityIdRequest {
    /**
     * 
     */
    facilityId: string;
}

export interface FindOneIntegrationSettingsByFacilityIdRequest {
    /**
     * 
     */
    facilityId: string;
}

export interface FindOnePccAdvancedPatientDetailsRequest {
    /**
     * 
     */
    leadId: string;
}

export interface FindOnePccPatientRequest {
    /**
     * 
     */
    leadId: string;
}

export interface FindOnePccPendingPatientRequest {
    /**
     * 
     */
    leadId: string;
}

export interface FindOneSourceRequest {
    /**
     * 
     */
    sourceId: string;
}

export interface FindPatientLeadsRequest {
    /**
     * 
     */
    patientId: string;
}

export interface FindReadmissionCandidatesRequest {
    /**
     * 
     */
    leadId: string;
}

export interface FindSOffenderRecordsForLeadRequest {
    /**
     * 
     */
    leadId: string;
}

export interface GenerateReportRequest {
    /**
     * 
     */
    leadId: string;
    /**
     * 
     */
    reportType: ScreenerGeneratedDocumentType;
    /**
     * Required for insurance_eligibility_check report type
     */
    checkId?: string;
}

export interface GenerateSOffenderRecordsReportRequest {
    /**
     * 
     */
    leadId: string;
}

export interface GetGeneratedReportDownloadUrlRequest {
    /**
     * 
     */
    leadId: string;
    /**
     * 
     */
    reportType: ScreenerGeneratedDocumentType;
    /**
     * Required for insurance_eligibility_check report type
     */
    checkId?: string;
}

export interface GetPccDemographicsPrefillRequest {
    /**
     * 
     */
    leadId: string;
}

export interface GetPccPicklistRequest {
    /**
     * 
     */
    leadId: string;
}

export interface IgnoreDuplicateCheckForLeadRequest {
    /**
     * 
     */
    leadId: string;
}

export interface ListGeneratedReportsRequest {
    /**
     * 
     */
    leadId: string;
}

export interface PatchPccDemographicsOperationRequest {
    /**
     * 
     */
    leadId: string;
    /**
     * 
     */
    patchPccDemographicsRequest: PatchPccDemographicsRequest;
}

export interface ReadmitToFacilityOperationRequest {
    /**
     * 
     */
    readmitToFacilityRequest: ReadmitToFacilityRequest;
}

export interface ReorderAssignmentRulesOperationRequest {
    /**
     * 
     */
    reorderAssignmentRulesRequest: ReorderAssignmentRulesRequest;
}

export interface ReturnToFacilityOperationRequest {
    /**
     * 
     */
    leadId: string;
    /**
     * 
     */
    returnToFacilityRequest: ReturnToFacilityRequest;
}

export interface RevertAdmissionStatusByIdRequest {
    /**
     * 
     */
    leadId: string;
    /**
     * 
     */
    revertAdmissionStatusRequest?: RevertAdmissionStatusRequest;
}

export interface SetLeadAssignmentsOperationRequest {
    /**
     * 
     */
    leadId: string;
    /**
     * 
     */
    setLeadAssignmentsRequest: SetLeadAssignmentsRequest;
}

export interface SyncLeadSOffenderRecordsByIdOperationRequest {
    /**
     * 
     */
    leadId: string;
    /**
     * 
     */
    syncLeadSOffenderRecordsByIdRequest: SyncLeadSOffenderRecordsByIdRequest;
}

export interface UnclaimLeadByIdRequest {
    /**
     * 
     */
    leadId: string;
}

export interface UpdateAdmissionStatusByIdRequest {
    /**
     * 
     */
    leadId: string;
    /**
     * 
     */
    updateAdmissionStatusRequest: UpdateAdmissionStatusRequest;
}

export interface UpdateAssignmentRuleOperationRequest {
    /**
     * 
     */
    ruleId: string;
    /**
     * 
     */
    updateAssignmentRuleRequest: UpdateAssignmentRuleRequest;
}

export interface UpdateDecisionOnLeadByIdRequest {
    /**
     * 
     */
    leadId: string;
    /**
     * 
     */
    updateLeadDecisionRequest: UpdateLeadDecisionRequest;
}

export interface UpdateIntegrationSettingsByFacilityIdRequest {
    /**
     * 
     */
    facilityId: string;
    /**
     * 
     */
    integrationSettings: IntegrationSettings;
}

export interface UpdateLeadAssignmentOperationRequest {
    /**
     * 
     */
    leadId: string;
    /**
     * 
     */
    assignmentId: string;
    /**
     * 
     */
    updateLeadAssignmentRequest: UpdateLeadAssignmentRequest;
}

export interface UpdateLeadByIdRequest {
    /**
     * 
     */
    leadId: string;
    /**
     * 
     */
    lead: Omit<Lead, 'source_deleted'|'home_health_practitioner_assignments'>;
}

export interface UpdateLeadCommentByIdRequest {
    /**
     * 
     */
    commentId: string;
    /**
     * 
     */
    leadComment: LeadComment;
}

export interface UpdateLeadSOffenderRecordByIdRequest {
    /**
     * 
     */
    sOffenderRecordId: string;
    /**
     * 
     */
    updateLeadSOffenderRecordRequest: UpdateLeadSOffenderRecordRequest;
}

export interface UpdatePreviousStayByIdRequest {
    /**
     * 
     */
    leadId: string;
    /**
     * 
     */
    updatePreviousStayRequest: UpdatePreviousStayRequest;
}

export interface UpdateSourceByIdRequest {
    /**
     * 
     */
    sourceId: string;
    /**
     * 
     */
    source: Omit<Source, 'merged_into'|'is_deleted'|'merged_into_source'>;
}

export interface UpdateSourceContactByIdRequest {
    /**
     * 
     */
    contactId: string;
    /**
     * 
     */
    sourceContact: SourceContact;
}

export interface UpdateSpecialCriteriaByIdOperationRequest {
    /**
     * 
     */
    criteriaId: string;
    /**
     * 
     */
    updateSpecialCriteriaByIdRequest: UpdateSpecialCriteriaByIdRequest;
}

export interface UploadPccAdvancedPatientDetailsRequest {
    /**
     * 
     */
    leadId: string;
    /**
     * 
     */
    pccAdvancedPatientDetails: PccAdvancedPatientDetails;
}

export interface UploadPccPatientDetailsOperationRequest {
    /**
     * 
     */
    leadId: string;
    /**
     * 
     */
    uploadPccPatientDetailsRequest: UploadPccPatientDetailsRequest;
}

/**
 * 
 */
export class DefaultApi extends runtime.BaseAPI {

    /**
     * Creates request options for bulkUpdateLeadSOffenderRecords without sending the request
     */
    async bulkUpdateLeadSOffenderRecordsRequestOpts(requestParameters: BulkUpdateLeadSOffenderRecordsOperationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['leadId'] == null) {
            throw new runtime.RequiredError(
                'leadId',
                'Required parameter "leadId" was null or undefined when calling bulkUpdateLeadSOffenderRecords().'
            );
        }

        if (requestParameters['bulkUpdateLeadSOffenderRecordsRequest'] == null) {
            throw new runtime.RequiredError(
                'bulkUpdateLeadSOffenderRecordsRequest',
                'Required parameter "bulkUpdateLeadSOffenderRecordsRequest" was null or undefined when calling bulkUpdateLeadSOffenderRecords().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/leads/{lead_id}/s-offender-records/bulk`;
        urlPath = urlPath.replace('{lead_id}', encodeURIComponent(String(requestParameters['leadId'])));

        return {
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: BulkUpdateLeadSOffenderRecordsRequestToJSON(requestParameters['bulkUpdateLeadSOffenderRecordsRequest']),
        };
    }

    /**
     * Bulk update lead s. offender records by IDs
     */
    async bulkUpdateLeadSOffenderRecordsRaw(requestParameters: BulkUpdateLeadSOffenderRecordsOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FindSOffenderRecordsForLead200Response>> {
        const requestOptions = await this.bulkUpdateLeadSOffenderRecordsRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FindSOffenderRecordsForLead200ResponseFromJSON(jsonValue));
    }

    /**
     * Bulk update lead s. offender records by IDs
     */
    async bulkUpdateLeadSOffenderRecords(requestParameters: BulkUpdateLeadSOffenderRecordsOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FindSOffenderRecordsForLead200Response> {
        const response = await this.bulkUpdateLeadSOffenderRecordsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for bulkUpdateSourceContactTags without sending the request
     */
    async bulkUpdateSourceContactTagsRequestOpts(requestParameters: BulkUpdateSourceContactTagsOperationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['bulkUpdateSourceContactTagsRequest'] == null) {
            throw new runtime.RequiredError(
                'bulkUpdateSourceContactTagsRequest',
                'Required parameter "bulkUpdateSourceContactTagsRequest" was null or undefined when calling bulkUpdateSourceContactTags().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/source-contact-tags`;

        return {
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: BulkUpdateSourceContactTagsRequestToJSON(requestParameters['bulkUpdateSourceContactTagsRequest']),
        };
    }

    /**
     * Bulk update screener source contact tags
     */
    async bulkUpdateSourceContactTagsRaw(requestParameters: BulkUpdateSourceContactTagsOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FindAllSourceContactTags200Response>> {
        const requestOptions = await this.bulkUpdateSourceContactTagsRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FindAllSourceContactTags200ResponseFromJSON(jsonValue));
    }

    /**
     * Bulk update screener source contact tags
     */
    async bulkUpdateSourceContactTags(requestParameters: BulkUpdateSourceContactTagsOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FindAllSourceContactTags200Response> {
        const response = await this.bulkUpdateSourceContactTagsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for cancelLeadById without sending the request
     */
    async cancelLeadByIdRequestOpts(requestParameters: CancelLeadByIdRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['leadId'] == null) {
            throw new runtime.RequiredError(
                'leadId',
                'Required parameter "leadId" was null or undefined when calling cancelLeadById().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/leads/{lead_id}/cancel`;
        urlPath = urlPath.replace('{lead_id}', encodeURIComponent(String(requestParameters['leadId'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Cancel a screener lead by ID
     */
    async cancelLeadByIdRaw(requestParameters: CancelLeadByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreateLead201Response>> {
        const requestOptions = await this.cancelLeadByIdRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CreateLead201ResponseFromJSON(jsonValue));
    }

    /**
     * Cancel a screener lead by ID
     */
    async cancelLeadById(requestParameters: CancelLeadByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreateLead201Response> {
        const response = await this.cancelLeadByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for claimLeadById without sending the request
     */
    async claimLeadByIdRequestOpts(requestParameters: ClaimLeadByIdRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['leadId'] == null) {
            throw new runtime.RequiredError(
                'leadId',
                'Required parameter "leadId" was null or undefined when calling claimLeadById().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/leads/{lead_id}/claim`;
        urlPath = urlPath.replace('{lead_id}', encodeURIComponent(String(requestParameters['leadId'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Claim a screener lead by ID by given facility
     */
    async claimLeadByIdRaw(requestParameters: ClaimLeadByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreateLead201Response>> {
        const requestOptions = await this.claimLeadByIdRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CreateLead201ResponseFromJSON(jsonValue));
    }

    /**
     * Claim a screener lead by ID by given facility
     */
    async claimLeadById(requestParameters: ClaimLeadByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreateLead201Response> {
        const response = await this.claimLeadByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for createAssignmentRule without sending the request
     */
    async createAssignmentRuleRequestOpts(requestParameters: CreateAssignmentRuleOperationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['createAssignmentRuleRequest'] == null) {
            throw new runtime.RequiredError(
                'createAssignmentRuleRequest',
                'Required parameter "createAssignmentRuleRequest" was null or undefined when calling createAssignmentRule().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/assignment-rules`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateAssignmentRuleRequestToJSON(requestParameters['createAssignmentRuleRequest']),
        };
    }

    /**
     * Create an auto-allocation assignment rule
     */
    async createAssignmentRuleRaw(requestParameters: CreateAssignmentRuleOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreateAssignmentRule201Response>> {
        const requestOptions = await this.createAssignmentRuleRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CreateAssignmentRule201ResponseFromJSON(jsonValue));
    }

    /**
     * Create an auto-allocation assignment rule
     */
    async createAssignmentRule(requestParameters: CreateAssignmentRuleOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreateAssignmentRule201Response> {
        const response = await this.createAssignmentRuleRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for createDocumentForLead without sending the request
     */
    async createDocumentForLeadRequestOpts(requestParameters: CreateDocumentForLeadRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['leadId'] == null) {
            throw new runtime.RequiredError(
                'leadId',
                'Required parameter "leadId" was null or undefined when calling createDocumentForLead().'
            );
        }

        if (requestParameters['document'] == null) {
            throw new runtime.RequiredError(
                'document',
                'Required parameter "document" was null or undefined when calling createDocumentForLead().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/leads/{lead_id}/documents`;
        urlPath = urlPath.replace('{lead_id}', encodeURIComponent(String(requestParameters['leadId'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: DocumentToJSON(requestParameters['document']),
        };
    }

    /**
     * Create a new document for a screener lead by ID
     */
    async createDocumentForLeadRaw(requestParameters: CreateDocumentForLeadRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreateDocumentForLead201Response>> {
        const requestOptions = await this.createDocumentForLeadRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CreateDocumentForLead201ResponseFromJSON(jsonValue));
    }

    /**
     * Create a new document for a screener lead by ID
     */
    async createDocumentForLead(requestParameters: CreateDocumentForLeadRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreateDocumentForLead201Response> {
        const response = await this.createDocumentForLeadRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for createIntakeIntegration without sending the request
     */
    async createIntakeIntegrationRequestOpts(requestParameters: CreateIntakeIntegrationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['facilityId'] == null) {
            throw new runtime.RequiredError(
                'facilityId',
                'Required parameter "facilityId" was null or undefined when calling createIntakeIntegration().'
            );
        }

        if (requestParameters['integrationCredentials'] == null) {
            throw new runtime.RequiredError(
                'integrationCredentials',
                'Required parameter "integrationCredentials" was null or undefined when calling createIntakeIntegration().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/facilities/{facility_id}/integrations`;
        urlPath = urlPath.replace('{facility_id}', encodeURIComponent(String(requestParameters['facilityId'])));

        return {
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: IntegrationCredentialsToJSON(requestParameters['integrationCredentials']),
        };
    }

    /**
     * Create a facility intake integration credentials
     */
    async createIntakeIntegrationRaw(requestParameters: CreateIntakeIntegrationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreateIntakeIntegration200Response>> {
        const requestOptions = await this.createIntakeIntegrationRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CreateIntakeIntegration200ResponseFromJSON(jsonValue));
    }

    /**
     * Create a facility intake integration credentials
     */
    async createIntakeIntegration(requestParameters: CreateIntakeIntegrationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreateIntakeIntegration200Response> {
        const response = await this.createIntakeIntegrationRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for createLead without sending the request
     */
    async createLeadRequestOpts(requestParameters: CreateLeadOperationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['createLeadRequest'] == null) {
            throw new runtime.RequiredError(
                'createLeadRequest',
                'Required parameter "createLeadRequest" was null or undefined when calling createLead().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/leads`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateLeadRequestToJSON(requestParameters['createLeadRequest']),
        };
    }

    /**
     * Create a screener lead
     */
    async createLeadRaw(requestParameters: CreateLeadOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreateLead201Response>> {
        const requestOptions = await this.createLeadRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CreateLead201ResponseFromJSON(jsonValue));
    }

    /**
     * Create a screener lead
     */
    async createLead(requestParameters: CreateLeadOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreateLead201Response> {
        const response = await this.createLeadRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for createLeadAssignment without sending the request
     */
    async createLeadAssignmentRequestOpts(requestParameters: CreateLeadAssignmentOperationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['leadId'] == null) {
            throw new runtime.RequiredError(
                'leadId',
                'Required parameter "leadId" was null or undefined when calling createLeadAssignment().'
            );
        }

        if (requestParameters['createLeadAssignmentRequest'] == null) {
            throw new runtime.RequiredError(
                'createLeadAssignmentRequest',
                'Required parameter "createLeadAssignmentRequest" was null or undefined when calling createLeadAssignment().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/leads/{lead_id}/assignments`;
        urlPath = urlPath.replace('{lead_id}', encodeURIComponent(String(requestParameters['leadId'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateLeadAssignmentRequestToJSON(requestParameters['createLeadAssignmentRequest']),
        };
    }

    /**
     * Assign a user to a referral as Owner or Source Liaison
     */
    async createLeadAssignmentRaw(requestParameters: CreateLeadAssignmentOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreateLeadAssignment200Response>> {
        const requestOptions = await this.createLeadAssignmentRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CreateLeadAssignment200ResponseFromJSON(jsonValue));
    }

    /**
     * Assign a user to a referral as Owner or Source Liaison
     */
    async createLeadAssignment(requestParameters: CreateLeadAssignmentOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreateLeadAssignment200Response> {
        const response = await this.createLeadAssignmentRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for createLeadComment without sending the request
     */
    async createLeadCommentRequestOpts(requestParameters: CreateLeadCommentRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['leadId'] == null) {
            throw new runtime.RequiredError(
                'leadId',
                'Required parameter "leadId" was null or undefined when calling createLeadComment().'
            );
        }

        if (requestParameters['leadComment'] == null) {
            throw new runtime.RequiredError(
                'leadComment',
                'Required parameter "leadComment" was null or undefined when calling createLeadComment().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/leads/{lead_id}/comments`;
        urlPath = urlPath.replace('{lead_id}', encodeURIComponent(String(requestParameters['leadId'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: LeadCommentToJSON(requestParameters['leadComment']),
        };
    }

    /**
     * Create a lead comment
     */
    async createLeadCommentRaw(requestParameters: CreateLeadCommentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreateLeadComment201Response>> {
        const requestOptions = await this.createLeadCommentRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CreateLeadComment201ResponseFromJSON(jsonValue));
    }

    /**
     * Create a lead comment
     */
    async createLeadComment(requestParameters: CreateLeadCommentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreateLeadComment201Response> {
        const response = await this.createLeadCommentRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for createOrDeleteLeadCommentReaction without sending the request
     */
    async createOrDeleteLeadCommentReactionRequestOpts(requestParameters: CreateOrDeleteLeadCommentReactionOperationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['commentId'] == null) {
            throw new runtime.RequiredError(
                'commentId',
                'Required parameter "commentId" was null or undefined when calling createOrDeleteLeadCommentReaction().'
            );
        }

        if (requestParameters['createOrDeleteLeadCommentReactionRequest'] == null) {
            throw new runtime.RequiredError(
                'createOrDeleteLeadCommentReactionRequest',
                'Required parameter "createOrDeleteLeadCommentReactionRequest" was null or undefined when calling createOrDeleteLeadCommentReaction().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/lead-comments/{comment_id}/reactions`;
        urlPath = urlPath.replace('{comment_id}', encodeURIComponent(String(requestParameters['commentId'])));

        return {
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: CreateOrDeleteLeadCommentReactionRequestToJSON(requestParameters['createOrDeleteLeadCommentReactionRequest']),
        };
    }

    /**
     * create a new reaction
     */
    async createOrDeleteLeadCommentReactionRaw(requestParameters: CreateOrDeleteLeadCommentReactionOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreateOrDeleteLeadCommentReaction200Response>> {
        const requestOptions = await this.createOrDeleteLeadCommentReactionRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CreateOrDeleteLeadCommentReaction200ResponseFromJSON(jsonValue));
    }

    /**
     * create a new reaction
     */
    async createOrDeleteLeadCommentReaction(requestParameters: CreateOrDeleteLeadCommentReactionOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreateOrDeleteLeadCommentReaction200Response> {
        const response = await this.createOrDeleteLeadCommentReactionRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for createPccPatient without sending the request
     */
    async createPccPatientRequestOpts(requestParameters: CreatePccPatientOperationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['leadId'] == null) {
            throw new runtime.RequiredError(
                'leadId',
                'Required parameter "leadId" was null or undefined when calling createPccPatient().'
            );
        }

        if (requestParameters['createPccPatientRequest'] == null) {
            throw new runtime.RequiredError(
                'createPccPatientRequest',
                'Required parameter "createPccPatientRequest" was null or undefined when calling createPccPatient().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/leads/{lead_id}/pcc/patients`;
        urlPath = urlPath.replace('{lead_id}', encodeURIComponent(String(requestParameters['leadId'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreatePccPatientRequestToJSON(requestParameters['createPccPatientRequest']),
        };
    }

    /**
     * Create a PCC patient
     */
    async createPccPatientRaw(requestParameters: CreatePccPatientOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreatePccPatient201Response>> {
        const requestOptions = await this.createPccPatientRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CreatePccPatient201ResponseFromJSON(jsonValue));
    }

    /**
     * Create a PCC patient
     */
    async createPccPatient(requestParameters: CreatePccPatientOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreatePccPatient201Response> {
        const response = await this.createPccPatientRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for createSource without sending the request
     */
    async createSourceRequestOpts(requestParameters: CreateSourceRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['source'] == null) {
            throw new runtime.RequiredError(
                'source',
                'Required parameter "source" was null or undefined when calling createSource().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/sources`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SourceToJSON(requestParameters['source']),
        };
    }

    /**
     * Create a source
     */
    async createSourceRaw(requestParameters: CreateSourceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreateSource201Response>> {
        const requestOptions = await this.createSourceRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CreateSource201ResponseFromJSON(jsonValue));
    }

    /**
     * Create a source
     */
    async createSource(requestParameters: CreateSourceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreateSource201Response> {
        const response = await this.createSourceRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for createSourceContact without sending the request
     */
    async createSourceContactRequestOpts(requestParameters: CreateSourceContactRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['sourceContact'] == null) {
            throw new runtime.RequiredError(
                'sourceContact',
                'Required parameter "sourceContact" was null or undefined when calling createSourceContact().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/source-contacts`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SourceContactToJSON(requestParameters['sourceContact']),
        };
    }

    /**
     * Create a screener source contact
     */
    async createSourceContactRaw(requestParameters: CreateSourceContactRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreateSourceContact201Response>> {
        const requestOptions = await this.createSourceContactRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CreateSourceContact201ResponseFromJSON(jsonValue));
    }

    /**
     * Create a screener source contact
     */
    async createSourceContact(requestParameters: CreateSourceContactRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreateSourceContact201Response> {
        const response = await this.createSourceContactRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for createSourceContactTag without sending the request
     */
    async createSourceContactTagRequestOpts(requestParameters: CreateSourceContactTagRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['sourceContactTag'] == null) {
            throw new runtime.RequiredError(
                'sourceContactTag',
                'Required parameter "sourceContactTag" was null or undefined when calling createSourceContactTag().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/source-contact-tags`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SourceContactTagToJSON(requestParameters['sourceContactTag']),
        };
    }

    /**
     * Create a screener source contact tag
     */
    async createSourceContactTagRaw(requestParameters: CreateSourceContactTagRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreateSourceContactTag201Response>> {
        const requestOptions = await this.createSourceContactTagRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CreateSourceContactTag201ResponseFromJSON(jsonValue));
    }

    /**
     * Create a screener source contact tag
     */
    async createSourceContactTag(requestParameters: CreateSourceContactTagRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreateSourceContactTag201Response> {
        const response = await this.createSourceContactTagRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for deleteAssignmentRule without sending the request
     */
    async deleteAssignmentRuleRequestOpts(requestParameters: DeleteAssignmentRuleRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['ruleId'] == null) {
            throw new runtime.RequiredError(
                'ruleId',
                'Required parameter "ruleId" was null or undefined when calling deleteAssignmentRule().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/assignment-rules/{rule_id}`;
        urlPath = urlPath.replace('{rule_id}', encodeURIComponent(String(requestParameters['ruleId'])));

        return {
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Delete an auto-allocation assignment rule
     */
    async deleteAssignmentRuleRaw(requestParameters: DeleteAssignmentRuleRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.deleteAssignmentRuleRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete an auto-allocation assignment rule
     */
    async deleteAssignmentRule(requestParameters: DeleteAssignmentRuleRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteAssignmentRuleRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for deleteDocumentForLead without sending the request
     */
    async deleteDocumentForLeadRequestOpts(requestParameters: DeleteDocumentForLeadRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['leadId'] == null) {
            throw new runtime.RequiredError(
                'leadId',
                'Required parameter "leadId" was null or undefined when calling deleteDocumentForLead().'
            );
        }

        if (requestParameters['documentId'] == null) {
            throw new runtime.RequiredError(
                'documentId',
                'Required parameter "documentId" was null or undefined when calling deleteDocumentForLead().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/leads/{lead_id}/documents/{document_id}`;
        urlPath = urlPath.replace('{lead_id}', encodeURIComponent(String(requestParameters['leadId'])));
        urlPath = urlPath.replace('{document_id}', encodeURIComponent(String(requestParameters['documentId'])));

        return {
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Delete document for a screener lead by ID
     */
    async deleteDocumentForLeadRaw(requestParameters: DeleteDocumentForLeadRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.deleteDocumentForLeadRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete document for a screener lead by ID
     */
    async deleteDocumentForLead(requestParameters: DeleteDocumentForLeadRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteDocumentForLeadRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for deleteLeadAssignment without sending the request
     */
    async deleteLeadAssignmentRequestOpts(requestParameters: DeleteLeadAssignmentRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['leadId'] == null) {
            throw new runtime.RequiredError(
                'leadId',
                'Required parameter "leadId" was null or undefined when calling deleteLeadAssignment().'
            );
        }

        if (requestParameters['assignmentId'] == null) {
            throw new runtime.RequiredError(
                'assignmentId',
                'Required parameter "assignmentId" was null or undefined when calling deleteLeadAssignment().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/leads/{lead_id}/assignments/{assignment_id}`;
        urlPath = urlPath.replace('{lead_id}', encodeURIComponent(String(requestParameters['leadId'])));
        urlPath = urlPath.replace('{assignment_id}', encodeURIComponent(String(requestParameters['assignmentId'])));

        return {
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Remove an assignment from a referral
     */
    async deleteLeadAssignmentRaw(requestParameters: DeleteLeadAssignmentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DeleteLeadAssignment200Response>> {
        const requestOptions = await this.deleteLeadAssignmentRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DeleteLeadAssignment200ResponseFromJSON(jsonValue));
    }

    /**
     * Remove an assignment from a referral
     */
    async deleteLeadAssignment(requestParameters: DeleteLeadAssignmentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DeleteLeadAssignment200Response> {
        const response = await this.deleteLeadAssignmentRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for deleteLeadById without sending the request
     */
    async deleteLeadByIdRequestOpts(requestParameters: DeleteLeadByIdRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['leadId'] == null) {
            throw new runtime.RequiredError(
                'leadId',
                'Required parameter "leadId" was null or undefined when calling deleteLeadById().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/leads/{lead_id}`;
        urlPath = urlPath.replace('{lead_id}', encodeURIComponent(String(requestParameters['leadId'])));

        return {
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Delete a screener lead by ID
     */
    async deleteLeadByIdRaw(requestParameters: DeleteLeadByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.deleteLeadByIdRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete a screener lead by ID
     */
    async deleteLeadById(requestParameters: DeleteLeadByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteLeadByIdRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for deleteLeadCommentById without sending the request
     */
    async deleteLeadCommentByIdRequestOpts(requestParameters: DeleteLeadCommentByIdRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['commentId'] == null) {
            throw new runtime.RequiredError(
                'commentId',
                'Required parameter "commentId" was null or undefined when calling deleteLeadCommentById().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/lead-comments/{comment_id}`;
        urlPath = urlPath.replace('{comment_id}', encodeURIComponent(String(requestParameters['commentId'])));

        return {
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Delete a screener lead comment by ID
     */
    async deleteLeadCommentByIdRaw(requestParameters: DeleteLeadCommentByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.deleteLeadCommentByIdRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete a screener lead comment by ID
     */
    async deleteLeadCommentById(requestParameters: DeleteLeadCommentByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteLeadCommentByIdRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for deleteSourceById without sending the request
     */
    async deleteSourceByIdRequestOpts(requestParameters: DeleteSourceByIdRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['sourceId'] == null) {
            throw new runtime.RequiredError(
                'sourceId',
                'Required parameter "sourceId" was null or undefined when calling deleteSourceById().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/sources/{source_id}`;
        urlPath = urlPath.replace('{source_id}', encodeURIComponent(String(requestParameters['sourceId'])));

        return {
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Delete a screener source by ID and all attached contacts
     */
    async deleteSourceByIdRaw(requestParameters: DeleteSourceByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.deleteSourceByIdRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete a screener source by ID and all attached contacts
     */
    async deleteSourceById(requestParameters: DeleteSourceByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteSourceByIdRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for deleteSourceContactById without sending the request
     */
    async deleteSourceContactByIdRequestOpts(requestParameters: DeleteSourceContactByIdRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['contactId'] == null) {
            throw new runtime.RequiredError(
                'contactId',
                'Required parameter "contactId" was null or undefined when calling deleteSourceContactById().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/source-contacts/{contact_id}`;
        urlPath = urlPath.replace('{contact_id}', encodeURIComponent(String(requestParameters['contactId'])));

        return {
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Delete a screener source contact by ID
     */
    async deleteSourceContactByIdRaw(requestParameters: DeleteSourceContactByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.deleteSourceContactByIdRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete a screener source contact by ID
     */
    async deleteSourceContactById(requestParameters: DeleteSourceContactByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteSourceContactByIdRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for deleteSourceContactTagById without sending the request
     */
    async deleteSourceContactTagByIdRequestOpts(requestParameters: DeleteSourceContactTagByIdRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['tagId'] == null) {
            throw new runtime.RequiredError(
                'tagId',
                'Required parameter "tagId" was null or undefined when calling deleteSourceContactTagById().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/source-contact-tags/{tag_id}`;
        urlPath = urlPath.replace('{tag_id}', encodeURIComponent(String(requestParameters['tagId'])));

        return {
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Delete a screener source contact tag by ID
     */
    async deleteSourceContactTagByIdRaw(requestParameters: DeleteSourceContactTagByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.deleteSourceContactTagByIdRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete a screener source contact tag by ID
     */
    async deleteSourceContactTagById(requestParameters: DeleteSourceContactTagByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteSourceContactTagByIdRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for evaluateLeadById without sending the request
     */
    async evaluateLeadByIdRequestOpts(requestParameters: EvaluateLeadByIdRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['leadId'] == null) {
            throw new runtime.RequiredError(
                'leadId',
                'Required parameter "leadId" was null or undefined when calling evaluateLeadById().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/leads/{lead_id}/evaluate`;
        urlPath = urlPath.replace('{lead_id}', encodeURIComponent(String(requestParameters['leadId'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Trigger a screener lead evaluation by ID
     */
    async evaluateLeadByIdRaw(requestParameters: EvaluateLeadByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreateLead201Response>> {
        const requestOptions = await this.evaluateLeadByIdRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CreateLead201ResponseFromJSON(jsonValue));
    }

    /**
     * Trigger a screener lead evaluation by ID
     */
    async evaluateLeadById(requestParameters: EvaluateLeadByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreateLead201Response> {
        const response = await this.evaluateLeadByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for findAdmissionStatusOptions without sending the request
     */
    async findAdmissionStatusOptionsRequestOpts(requestParameters: FindAdmissionStatusOptionsOperationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['findAdmissionStatusOptionsRequest'] == null) {
            throw new runtime.RequiredError(
                'findAdmissionStatusOptionsRequest',
                'Required parameter "findAdmissionStatusOptionsRequest" was null or undefined when calling findAdmissionStatusOptions().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/leads/admission-status-options`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: FindAdmissionStatusOptionsRequestToJSON(requestParameters['findAdmissionStatusOptionsRequest']),
        };
    }

    /**
     * Get the admission-status options (forward + revert) for a batch of leads
     */
    async findAdmissionStatusOptionsRaw(requestParameters: FindAdmissionStatusOptionsOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FindAdmissionStatusOptions200Response>> {
        const requestOptions = await this.findAdmissionStatusOptionsRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FindAdmissionStatusOptions200ResponseFromJSON(jsonValue));
    }

    /**
     * Get the admission-status options (forward + revert) for a batch of leads
     */
    async findAdmissionStatusOptions(requestParameters: FindAdmissionStatusOptionsOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FindAdmissionStatusOptions200Response> {
        const response = await this.findAdmissionStatusOptionsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for findAllCommentsForLead without sending the request
     */
    async findAllCommentsForLeadRequestOpts(requestParameters: FindAllCommentsForLeadRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['leadId'] == null) {
            throw new runtime.RequiredError(
                'leadId',
                'Required parameter "leadId" was null or undefined when calling findAllCommentsForLead().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/leads/{lead_id}/comments`;
        urlPath = urlPath.replace('{lead_id}', encodeURIComponent(String(requestParameters['leadId'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Get comments for a screener lead
     */
    async findAllCommentsForLeadRaw(requestParameters: FindAllCommentsForLeadRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FindAllCommentsForLead200Response>> {
        const requestOptions = await this.findAllCommentsForLeadRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FindAllCommentsForLead200ResponseFromJSON(jsonValue));
    }

    /**
     * Get comments for a screener lead
     */
    async findAllCommentsForLead(requestParameters: FindAllCommentsForLeadRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FindAllCommentsForLead200Response> {
        const response = await this.findAllCommentsForLeadRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for findAllIntegrationsByFacilityId without sending the request
     */
    async findAllIntegrationsByFacilityIdRequestOpts(requestParameters: FindAllIntegrationsByFacilityIdRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['facilityId'] == null) {
            throw new runtime.RequiredError(
                'facilityId',
                'Required parameter "facilityId" was null or undefined when calling findAllIntegrationsByFacilityId().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/facilities/{facility_id}/integrations`;
        urlPath = urlPath.replace('{facility_id}', encodeURIComponent(String(requestParameters['facilityId'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Get screener integrations for facility
     */
    async findAllIntegrationsByFacilityIdRaw(requestParameters: FindAllIntegrationsByFacilityIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FindAllIntegrationsByFacilityId200Response>> {
        const requestOptions = await this.findAllIntegrationsByFacilityIdRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FindAllIntegrationsByFacilityId200ResponseFromJSON(jsonValue));
    }

    /**
     * Get screener integrations for facility
     */
    async findAllIntegrationsByFacilityId(requestParameters: FindAllIntegrationsByFacilityIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FindAllIntegrationsByFacilityId200Response> {
        const response = await this.findAllIntegrationsByFacilityIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for findAllLeadCalendarEvents without sending the request
     */
    async findAllLeadCalendarEventsRequestOpts(requestParameters: FindAllLeadCalendarEventsRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['startDate'] == null) {
            throw new runtime.RequiredError(
                'startDate',
                'Required parameter "startDate" was null or undefined when calling findAllLeadCalendarEvents().'
            );
        }

        if (requestParameters['endDate'] == null) {
            throw new runtime.RequiredError(
                'endDate',
                'Required parameter "endDate" was null or undefined when calling findAllLeadCalendarEvents().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['facilityId'] != null) {
            queryParameters['facility_id'] = requestParameters['facilityId'];
        }

        if (requestParameters['startDate'] != null) {
            queryParameters['start_date'] = runtime.serializeDate(requestParameters['startDate'] as any);
        }

        if (requestParameters['endDate'] != null) {
            queryParameters['end_date'] = runtime.serializeDate(requestParameters['endDate'] as any);
        }

        if (requestParameters['eventTypes'] != null) {
            queryParameters['event_types'] = requestParameters['eventTypes'];
        }

        if (requestParameters['includeCancelled'] != null) {
            queryParameters['include_cancelled'] = requestParameters['includeCancelled'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/leads/calendar-events`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Find calendar events (expected/actual start and end of care) across care settings
     */
    async findAllLeadCalendarEventsRaw(requestParameters: FindAllLeadCalendarEventsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FindAllLeadCalendarEvents200Response>> {
        const requestOptions = await this.findAllLeadCalendarEventsRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FindAllLeadCalendarEvents200ResponseFromJSON(jsonValue));
    }

    /**
     * Find calendar events (expected/actual start and end of care) across care settings
     */
    async findAllLeadCalendarEvents(requestParameters: FindAllLeadCalendarEventsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FindAllLeadCalendarEvents200Response> {
        const response = await this.findAllLeadCalendarEventsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for findAllLeadStatuses without sending the request
     */
    async findAllLeadStatusesRequestOpts(): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/lead-statuses`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Get all screener lead statuses
     */
    async findAllLeadStatusesRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FindAllLeadStatuses200Response>> {
        const requestOptions = await this.findAllLeadStatusesRequestOpts();
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FindAllLeadStatuses200ResponseFromJSON(jsonValue));
    }

    /**
     * Get all screener lead statuses
     */
    async findAllLeadStatuses(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FindAllLeadStatuses200Response> {
        const response = await this.findAllLeadStatusesRaw(initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for findAllLeads without sending the request
     */
    async findAllLeadsRequestOpts(requestParameters: FindAllLeadsRequest): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        if (requestParameters['facilityId'] != null) {
            queryParameters['facility_id'] = requestParameters['facilityId'];
        }

        if (requestParameters['sourceId'] != null) {
            queryParameters['source_id'] = requestParameters['sourceId'];
        }

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['suggestion'] != null) {
            queryParameters['suggestion'] = requestParameters['suggestion'];
        }

        if (requestParameters['includeCancelled'] != null) {
            queryParameters['include_cancelled'] = requestParameters['includeCancelled'];
        }

        if (requestParameters['includeOtherFacilityDuplicates'] != null) {
            queryParameters['include_other_facility_duplicates'] = requestParameters['includeOtherFacilityDuplicates'];
        }

        if (requestParameters['connector'] != null) {
            queryParameters['connector'] = requestParameters['connector'];
        }

        if (requestParameters['admissionStatus'] != null) {
            queryParameters['admission_status'] = requestParameters['admissionStatus'];
        }

        if (requestParameters['payerType'] != null) {
            queryParameters['payer_type'] = requestParameters['payerType'];
        }

        if (requestParameters['payer'] != null) {
            queryParameters['payer'] = requestParameters['payer'];
        }

        if (requestParameters['payerSource'] != null) {
            queryParameters['payer_source'] = requestParameters['payerSource'];
        }

        if (requestParameters['includeNullPayerType'] != null) {
            queryParameters['include_null_payer_type'] = requestParameters['includeNullPayerType'];
        }

        if (requestParameters['includeNullPayerSource'] != null) {
            queryParameters['include_null_payer_source'] = requestParameters['includeNullPayerSource'];
        }

        if (requestParameters['networkStatus'] != null) {
            queryParameters['network_status'] = requestParameters['networkStatus'];
        }

        if (requestParameters['pccStatus'] != null) {
            queryParameters['pcc_status'] = requestParameters['pccStatus'];
        }

        if (requestParameters['matrixCareStatus'] != null) {
            queryParameters['matrix_care_status'] = requestParameters['matrixCareStatus'];
        }

        if (requestParameters['statusId'] != null) {
            queryParameters['status_id'] = requestParameters['statusId'];
        }

        if (requestParameters['reviewStageAcceptSource'] != null) {
            queryParameters['review_stage_accept_source'] = requestParameters['reviewStageAcceptSource'];
        }

        if (requestParameters['includeEmptyAdmission'] != null) {
            queryParameters['include_empty_admission'] = requestParameters['includeEmptyAdmission'];
        }

        if (requestParameters['hasNewHospitalMessages'] != null) {
            queryParameters['has_new_hospital_messages'] = requestParameters['hasNewHospitalMessages'];
        }

        if (requestParameters['hasNewDocuments'] != null) {
            queryParameters['has_new_documents'] = requestParameters['hasNewDocuments'];
        }

        if (requestParameters['assigneeUserIds'] != null) {
            queryParameters['assignee_user_ids'] = requestParameters['assigneeUserIds'];
        }

        if (requestParameters['unassigned'] != null) {
            queryParameters['unassigned'] = requestParameters['unassigned'];
        }

        if (requestParameters['clinicalCareNeeds'] != null) {
            queryParameters['clinical_care_needs'] = requestParameters['clinicalCareNeeds'];
        }

        if (requestParameters['programs'] != null) {
            queryParameters['programs'] = requestParameters['programs'];
        }

        if (requestParameters['typesOfCare'] != null) {
            queryParameters['types_of_care'] = requestParameters['typesOfCare'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/leads`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Get all screener leads
     */
    async findAllLeadsRaw(requestParameters: FindAllLeadsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FindAllLeads200Response>> {
        const requestOptions = await this.findAllLeadsRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FindAllLeads200ResponseFromJSON(jsonValue));
    }

    /**
     * Get all screener leads
     */
    async findAllLeads(requestParameters: FindAllLeadsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FindAllLeads200Response> {
        const response = await this.findAllLeadsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for findAllPalIntegrationsByFacilityId without sending the request
     */
    async findAllPalIntegrationsByFacilityIdRequestOpts(requestParameters: FindAllPalIntegrationsByFacilityIdRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['facilityId'] == null) {
            throw new runtime.RequiredError(
                'facilityId',
                'Required parameter "facilityId" was null or undefined when calling findAllPalIntegrationsByFacilityId().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/facilities/{facility_id}/pal-integrations`;
        urlPath = urlPath.replace('{facility_id}', encodeURIComponent(String(requestParameters['facilityId'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Get PAL integrations for facility
     */
    async findAllPalIntegrationsByFacilityIdRaw(requestParameters: FindAllPalIntegrationsByFacilityIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FindAllPalIntegrationsByFacilityId200Response>> {
        const requestOptions = await this.findAllPalIntegrationsByFacilityIdRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FindAllPalIntegrationsByFacilityId200ResponseFromJSON(jsonValue));
    }

    /**
     * Get PAL integrations for facility
     */
    async findAllPalIntegrationsByFacilityId(requestParameters: FindAllPalIntegrationsByFacilityIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FindAllPalIntegrationsByFacilityId200Response> {
        const response = await this.findAllPalIntegrationsByFacilityIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for findAllScreenerSources without sending the request
     */
    async findAllScreenerSourcesRequestOpts(requestParameters: FindAllScreenerSourcesOperationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['findAllScreenerSourcesRequest'] == null) {
            throw new runtime.RequiredError(
                'findAllScreenerSourcesRequest',
                'Required parameter "findAllScreenerSourcesRequest" was null or undefined when calling findAllScreenerSources().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/sources/find-all`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: FindAllScreenerSourcesRequestToJSON(requestParameters['findAllScreenerSourcesRequest']),
        };
    }

    /**
     * Find all sources
     */
    async findAllScreenerSourcesRaw(requestParameters: FindAllScreenerSourcesOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FindAllScreenerSources200Response>> {
        const requestOptions = await this.findAllScreenerSourcesRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FindAllScreenerSources200ResponseFromJSON(jsonValue));
    }

    /**
     * Find all sources
     */
    async findAllScreenerSources(requestParameters: FindAllScreenerSourcesOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FindAllScreenerSources200Response> {
        const response = await this.findAllScreenerSourcesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for findAllSourceContactTags without sending the request
     */
    async findAllSourceContactTagsRequestOpts(): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/source-contact-tags`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Get all screener source contact tags
     */
    async findAllSourceContactTagsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FindAllSourceContactTags200Response>> {
        const requestOptions = await this.findAllSourceContactTagsRequestOpts();
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FindAllSourceContactTags200ResponseFromJSON(jsonValue));
    }

    /**
     * Get all screener source contact tags
     */
    async findAllSourceContactTags(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FindAllSourceContactTags200Response> {
        const response = await this.findAllSourceContactTagsRaw(initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for findAllSourceContacts without sending the request
     */
    async findAllSourceContactsRequestOpts(requestParameters: FindAllSourceContactsRequest): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        if (requestParameters['sourceId'] != null) {
            queryParameters['source_id'] = requestParameters['sourceId'];
        }

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/source-contacts`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Get all screener source contacts
     */
    async findAllSourceContactsRaw(requestParameters: FindAllSourceContactsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FindAllSourceContacts200Response>> {
        const requestOptions = await this.findAllSourceContactsRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FindAllSourceContacts200ResponseFromJSON(jsonValue));
    }

    /**
     * Get all screener source contacts
     */
    async findAllSourceContacts(requestParameters: FindAllSourceContactsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FindAllSourceContacts200Response> {
        const response = await this.findAllSourceContactsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for findAllSpecialCriteria without sending the request
     */
    async findAllSpecialCriteriaRequestOpts(requestParameters: FindAllSpecialCriteriaRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['facilityId'] == null) {
            throw new runtime.RequiredError(
                'facilityId',
                'Required parameter "facilityId" was null or undefined when calling findAllSpecialCriteria().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['facilityId'] != null) {
            queryParameters['facility_id'] = requestParameters['facilityId'];
        }

        if (requestParameters['informational'] != null) {
            queryParameters['informational'] = requestParameters['informational'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/special-criteria`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Get all special criteria by facility_id
     */
    async findAllSpecialCriteriaRaw(requestParameters: FindAllSpecialCriteriaRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FindAllSpecialCriteria200Response>> {
        const requestOptions = await this.findAllSpecialCriteriaRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FindAllSpecialCriteria200ResponseFromJSON(jsonValue));
    }

    /**
     * Get all special criteria by facility_id
     */
    async findAllSpecialCriteria(requestParameters: FindAllSpecialCriteriaRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FindAllSpecialCriteria200Response> {
        const response = await this.findAllSpecialCriteriaRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for findHospitalizedInstances without sending the request
     */
    async findHospitalizedInstancesRequestOpts(requestParameters: FindHospitalizedInstancesRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['leadId'] == null) {
            throw new runtime.RequiredError(
                'leadId',
                'Required parameter "leadId" was null or undefined when calling findHospitalizedInstances().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/leads/{lead_id}/hospitalized-instances`;
        urlPath = urlPath.replace('{lead_id}', encodeURIComponent(String(requestParameters['leadId'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Find hospitalized instances in the same duplicate group and facility
     */
    async findHospitalizedInstancesRaw(requestParameters: FindHospitalizedInstancesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FindHospitalizedInstances200Response>> {
        const requestOptions = await this.findHospitalizedInstancesRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FindHospitalizedInstances200ResponseFromJSON(jsonValue));
    }

    /**
     * Find hospitalized instances in the same duplicate group and facility
     */
    async findHospitalizedInstances(requestParameters: FindHospitalizedInstancesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FindHospitalizedInstances200Response> {
        const response = await this.findHospitalizedInstancesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for findLeadById without sending the request
     */
    async findLeadByIdRequestOpts(requestParameters: FindLeadByIdRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['leadId'] == null) {
            throw new runtime.RequiredError(
                'leadId',
                'Required parameter "leadId" was null or undefined when calling findLeadById().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/leads/{lead_id}`;
        urlPath = urlPath.replace('{lead_id}', encodeURIComponent(String(requestParameters['leadId'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Get a screener lead by ID
     */
    async findLeadByIdRaw(requestParameters: FindLeadByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreateLead201Response>> {
        const requestOptions = await this.findLeadByIdRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CreateLead201ResponseFromJSON(jsonValue));
    }

    /**
     * Get a screener lead by ID
     */
    async findLeadById(requestParameters: FindLeadByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreateLead201Response> {
        const response = await this.findLeadByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for findLeadsBatchWithCommentCounts without sending the request
     */
    async findLeadsBatchWithCommentCountsRequestOpts(requestParameters: FindLeadsBatchWithCommentCountsOperationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['findLeadsBatchWithCommentCountsRequest'] == null) {
            throw new runtime.RequiredError(
                'findLeadsBatchWithCommentCountsRequest',
                'Required parameter "findLeadsBatchWithCommentCountsRequest" was null or undefined when calling findLeadsBatchWithCommentCounts().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/leads/batch/comment-counts`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: FindLeadsBatchWithCommentCountsRequestToJSON(requestParameters['findLeadsBatchWithCommentCountsRequest']),
        };
    }

    /**
     * Get comment counts for multiple leads
     */
    async findLeadsBatchWithCommentCountsRaw(requestParameters: FindLeadsBatchWithCommentCountsOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FindLeadsBatchWithCommentCounts200Response>> {
        const requestOptions = await this.findLeadsBatchWithCommentCountsRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FindLeadsBatchWithCommentCounts200ResponseFromJSON(jsonValue));
    }

    /**
     * Get comment counts for multiple leads
     */
    async findLeadsBatchWithCommentCounts(requestParameters: FindLeadsBatchWithCommentCountsOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FindLeadsBatchWithCommentCounts200Response> {
        const response = await this.findLeadsBatchWithCommentCountsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for findLeadsBatchWithDocumentStats without sending the request
     */
    async findLeadsBatchWithDocumentStatsRequestOpts(requestParameters: FindLeadsBatchWithDocumentStatsOperationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['findLeadsBatchWithDocumentStatsRequest'] == null) {
            throw new runtime.RequiredError(
                'findLeadsBatchWithDocumentStatsRequest',
                'Required parameter "findLeadsBatchWithDocumentStatsRequest" was null or undefined when calling findLeadsBatchWithDocumentStats().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/leads/batch/document-stats`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: FindLeadsBatchWithDocumentStatsRequestToJSON(requestParameters['findLeadsBatchWithDocumentStatsRequest']),
        };
    }

    /**
     * Get document stats for multiple leads
     */
    async findLeadsBatchWithDocumentStatsRaw(requestParameters: FindLeadsBatchWithDocumentStatsOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FindLeadsBatchWithDocumentStats200Response>> {
        const requestOptions = await this.findLeadsBatchWithDocumentStatsRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FindLeadsBatchWithDocumentStats200ResponseFromJSON(jsonValue));
    }

    /**
     * Get document stats for multiple leads
     */
    async findLeadsBatchWithDocumentStats(requestParameters: FindLeadsBatchWithDocumentStatsOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FindLeadsBatchWithDocumentStats200Response> {
        const response = await this.findLeadsBatchWithDocumentStatsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for findMedicationsForLead without sending the request
     */
    async findMedicationsForLeadRequestOpts(requestParameters: FindMedicationsForLeadRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['leadId'] == null) {
            throw new runtime.RequiredError(
                'leadId',
                'Required parameter "leadId" was null or undefined when calling findMedicationsForLead().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/leads/{lead_id}/medications`;
        urlPath = urlPath.replace('{lead_id}', encodeURIComponent(String(requestParameters['leadId'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Get medications for a screener lead
     */
    async findMedicationsForLeadRaw(requestParameters: FindMedicationsForLeadRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FindMedicationsForLead200Response>> {
        const requestOptions = await this.findMedicationsForLeadRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FindMedicationsForLead200ResponseFromJSON(jsonValue));
    }

    /**
     * Get medications for a screener lead
     */
    async findMedicationsForLead(requestParameters: FindMedicationsForLeadRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FindMedicationsForLead200Response> {
        const response = await this.findMedicationsForLeadRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for findOneExecutionsAvailableByFacilityId without sending the request
     */
    async findOneExecutionsAvailableByFacilityIdRequestOpts(requestParameters: FindOneExecutionsAvailableByFacilityIdRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['facilityId'] == null) {
            throw new runtime.RequiredError(
                'facilityId',
                'Required parameter "facilityId" was null or undefined when calling findOneExecutionsAvailableByFacilityId().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/facilities/{facility_id}/executions-available`;
        urlPath = urlPath.replace('{facility_id}', encodeURIComponent(String(requestParameters['facilityId'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Get screener executions available for a facility
     */
    async findOneExecutionsAvailableByFacilityIdRaw(requestParameters: FindOneExecutionsAvailableByFacilityIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FindOneExecutionsAvailableByFacilityId200Response>> {
        const requestOptions = await this.findOneExecutionsAvailableByFacilityIdRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FindOneExecutionsAvailableByFacilityId200ResponseFromJSON(jsonValue));
    }

    /**
     * Get screener executions available for a facility
     */
    async findOneExecutionsAvailableByFacilityId(requestParameters: FindOneExecutionsAvailableByFacilityIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FindOneExecutionsAvailableByFacilityId200Response> {
        const response = await this.findOneExecutionsAvailableByFacilityIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for findOneIntegrationSettingsByFacilityId without sending the request
     */
    async findOneIntegrationSettingsByFacilityIdRequestOpts(requestParameters: FindOneIntegrationSettingsByFacilityIdRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['facilityId'] == null) {
            throw new runtime.RequiredError(
                'facilityId',
                'Required parameter "facilityId" was null or undefined when calling findOneIntegrationSettingsByFacilityId().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/facilities/{facility_id}/integrations/settings`;
        urlPath = urlPath.replace('{facility_id}', encodeURIComponent(String(requestParameters['facilityId'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Get screener integration settings for facility
     */
    async findOneIntegrationSettingsByFacilityIdRaw(requestParameters: FindOneIntegrationSettingsByFacilityIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FindOneIntegrationSettingsByFacilityId200Response>> {
        const requestOptions = await this.findOneIntegrationSettingsByFacilityIdRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FindOneIntegrationSettingsByFacilityId200ResponseFromJSON(jsonValue));
    }

    /**
     * Get screener integration settings for facility
     */
    async findOneIntegrationSettingsByFacilityId(requestParameters: FindOneIntegrationSettingsByFacilityIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FindOneIntegrationSettingsByFacilityId200Response> {
        const response = await this.findOneIntegrationSettingsByFacilityIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for findOnePccAdvancedPatientDetails without sending the request
     */
    async findOnePccAdvancedPatientDetailsRequestOpts(requestParameters: FindOnePccAdvancedPatientDetailsRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['leadId'] == null) {
            throw new runtime.RequiredError(
                'leadId',
                'Required parameter "leadId" was null or undefined when calling findOnePccAdvancedPatientDetails().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/leads/{lead_id}/pcc/patient/details/advanced`;
        urlPath = urlPath.replace('{lead_id}', encodeURIComponent(String(requestParameters['leadId'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Find One PCC advanced patient\'s details
     */
    async findOnePccAdvancedPatientDetailsRaw(requestParameters: FindOnePccAdvancedPatientDetailsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FindOnePccAdvancedPatientDetails200Response>> {
        const requestOptions = await this.findOnePccAdvancedPatientDetailsRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FindOnePccAdvancedPatientDetails200ResponseFromJSON(jsonValue));
    }

    /**
     * Find One PCC advanced patient\'s details
     */
    async findOnePccAdvancedPatientDetails(requestParameters: FindOnePccAdvancedPatientDetailsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FindOnePccAdvancedPatientDetails200Response> {
        const response = await this.findOnePccAdvancedPatientDetailsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for findOnePccPatient without sending the request
     */
    async findOnePccPatientRequestOpts(requestParameters: FindOnePccPatientRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['leadId'] == null) {
            throw new runtime.RequiredError(
                'leadId',
                'Required parameter "leadId" was null or undefined when calling findOnePccPatient().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/leads/{lead_id}/pcc/patients`;
        urlPath = urlPath.replace('{lead_id}', encodeURIComponent(String(requestParameters['leadId'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Find patient by lead ID
     */
    async findOnePccPatientRaw(requestParameters: FindOnePccPatientRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FindOnePccPatient200Response>> {
        const requestOptions = await this.findOnePccPatientRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FindOnePccPatient200ResponseFromJSON(jsonValue));
    }

    /**
     * Find patient by lead ID
     */
    async findOnePccPatient(requestParameters: FindOnePccPatientRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FindOnePccPatient200Response> {
        const response = await this.findOnePccPatientRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for findOnePccPendingPatient without sending the request
     */
    async findOnePccPendingPatientRequestOpts(requestParameters: FindOnePccPendingPatientRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['leadId'] == null) {
            throw new runtime.RequiredError(
                'leadId',
                'Required parameter "leadId" was null or undefined when calling findOnePccPendingPatient().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/leads/{lead_id}/pcc/pending-patients`;
        urlPath = urlPath.replace('{lead_id}', encodeURIComponent(String(requestParameters['leadId'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Find pending patient by lead ID
     */
    async findOnePccPendingPatientRaw(requestParameters: FindOnePccPendingPatientRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FindOnePccPendingPatient200Response>> {
        const requestOptions = await this.findOnePccPendingPatientRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FindOnePccPendingPatient200ResponseFromJSON(jsonValue));
    }

    /**
     * Find pending patient by lead ID
     */
    async findOnePccPendingPatient(requestParameters: FindOnePccPendingPatientRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FindOnePccPendingPatient200Response> {
        const response = await this.findOnePccPendingPatientRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for findOneSource without sending the request
     */
    async findOneSourceRequestOpts(requestParameters: FindOneSourceRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['sourceId'] == null) {
            throw new runtime.RequiredError(
                'sourceId',
                'Required parameter "sourceId" was null or undefined when calling findOneSource().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/sources/{source_id}`;
        urlPath = urlPath.replace('{source_id}', encodeURIComponent(String(requestParameters['sourceId'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Get one screener source
     */
    async findOneSourceRaw(requestParameters: FindOneSourceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreateSource201Response>> {
        const requestOptions = await this.findOneSourceRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CreateSource201ResponseFromJSON(jsonValue));
    }

    /**
     * Get one screener source
     */
    async findOneSource(requestParameters: FindOneSourceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreateSource201Response> {
        const response = await this.findOneSourceRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for findPatientLeads without sending the request
     */
    async findPatientLeadsRequestOpts(requestParameters: FindPatientLeadsRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['patientId'] == null) {
            throw new runtime.RequiredError(
                'patientId',
                'Required parameter "patientId" was null or undefined when calling findPatientLeads().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/patients/{patient_id}/leads`;
        urlPath = urlPath.replace('{patient_id}', encodeURIComponent(String(requestParameters['patientId'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Find leads belonging to a patient
     */
    async findPatientLeadsRaw(requestParameters: FindPatientLeadsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FindHospitalizedInstances200Response>> {
        const requestOptions = await this.findPatientLeadsRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FindHospitalizedInstances200ResponseFromJSON(jsonValue));
    }

    /**
     * Find leads belonging to a patient
     */
    async findPatientLeads(requestParameters: FindPatientLeadsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FindHospitalizedInstances200Response> {
        const response = await this.findPatientLeadsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for findReadmissionCandidates without sending the request
     */
    async findReadmissionCandidatesRequestOpts(requestParameters: FindReadmissionCandidatesRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['leadId'] == null) {
            throw new runtime.RequiredError(
                'leadId',
                'Required parameter "leadId" was null or undefined when calling findReadmissionCandidates().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/leads/{lead_id}/readmission-candidates`;
        urlPath = urlPath.replace('{lead_id}', encodeURIComponent(String(requestParameters['leadId'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Find readmission candidates in the same duplicate group and facility
     */
    async findReadmissionCandidatesRaw(requestParameters: FindReadmissionCandidatesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FindHospitalizedInstances200Response>> {
        const requestOptions = await this.findReadmissionCandidatesRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FindHospitalizedInstances200ResponseFromJSON(jsonValue));
    }

    /**
     * Find readmission candidates in the same duplicate group and facility
     */
    async findReadmissionCandidates(requestParameters: FindReadmissionCandidatesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FindHospitalizedInstances200Response> {
        const response = await this.findReadmissionCandidatesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for findSOffenderRecordsForLead without sending the request
     */
    async findSOffenderRecordsForLeadRequestOpts(requestParameters: FindSOffenderRecordsForLeadRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['leadId'] == null) {
            throw new runtime.RequiredError(
                'leadId',
                'Required parameter "leadId" was null or undefined when calling findSOffenderRecordsForLead().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/leads/{lead_id}/s-offender-records`;
        urlPath = urlPath.replace('{lead_id}', encodeURIComponent(String(requestParameters['leadId'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Get s offender records for a screener lead
     */
    async findSOffenderRecordsForLeadRaw(requestParameters: FindSOffenderRecordsForLeadRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FindSOffenderRecordsForLead200Response>> {
        const requestOptions = await this.findSOffenderRecordsForLeadRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FindSOffenderRecordsForLead200ResponseFromJSON(jsonValue));
    }

    /**
     * Get s offender records for a screener lead
     */
    async findSOffenderRecordsForLead(requestParameters: FindSOffenderRecordsForLeadRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FindSOffenderRecordsForLead200Response> {
        const response = await this.findSOffenderRecordsForLeadRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for generateReport without sending the request
     */
    async generateReportRequestOpts(requestParameters: GenerateReportRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['leadId'] == null) {
            throw new runtime.RequiredError(
                'leadId',
                'Required parameter "leadId" was null or undefined when calling generateReport().'
            );
        }

        if (requestParameters['reportType'] == null) {
            throw new runtime.RequiredError(
                'reportType',
                'Required parameter "reportType" was null or undefined when calling generateReport().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['checkId'] != null) {
            queryParameters['check_id'] = requestParameters['checkId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/leads/{lead_id}/generated-reports/{report_type}`;
        urlPath = urlPath.replace('{lead_id}', encodeURIComponent(String(requestParameters['leadId'])));
        urlPath = urlPath.replace('{report_type}', encodeURIComponent(String(requestParameters['reportType'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Generate any type of report for a screener lead synchronously. Throws an error if the report is not yet available.
     * Generate a report for a screener lead
     */
    async generateReportRaw(requestParameters: GenerateReportRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GenerateReport200Response>> {
        const requestOptions = await this.generateReportRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GenerateReport200ResponseFromJSON(jsonValue));
    }

    /**
     * Generate any type of report for a screener lead synchronously. Throws an error if the report is not yet available.
     * Generate a report for a screener lead
     */
    async generateReport(requestParameters: GenerateReportRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GenerateReport200Response> {
        const response = await this.generateReportRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for generateSOffenderRecordsReport without sending the request
     * @deprecated
     */
    async generateSOffenderRecordsReportRequestOpts(requestParameters: GenerateSOffenderRecordsReportRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['leadId'] == null) {
            throw new runtime.RequiredError(
                'leadId',
                'Required parameter "leadId" was null or undefined when calling generateSOffenderRecordsReport().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/leads/{lead_id}/s-offender-records/report`;
        urlPath = urlPath.replace('{lead_id}', encodeURIComponent(String(requestParameters['leadId'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Deprecated. Use /leads/{lead_id}/generated-reports/{report_type} instead.
     * Get s offender records report for a screener lead
     * @deprecated
     */
    async generateSOffenderRecordsReportRaw(requestParameters: GenerateSOffenderRecordsReportRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GenerateSOffenderRecordsReport200Response>> {
        const requestOptions = await this.generateSOffenderRecordsReportRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GenerateSOffenderRecordsReport200ResponseFromJSON(jsonValue));
    }

    /**
     * Deprecated. Use /leads/{lead_id}/generated-reports/{report_type} instead.
     * Get s offender records report for a screener lead
     * @deprecated
     */
    async generateSOffenderRecordsReport(requestParameters: GenerateSOffenderRecordsReportRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GenerateSOffenderRecordsReport200Response> {
        const response = await this.generateSOffenderRecordsReportRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getGeneratedReportDownloadUrl without sending the request
     */
    async getGeneratedReportDownloadUrlRequestOpts(requestParameters: GetGeneratedReportDownloadUrlRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['leadId'] == null) {
            throw new runtime.RequiredError(
                'leadId',
                'Required parameter "leadId" was null or undefined when calling getGeneratedReportDownloadUrl().'
            );
        }

        if (requestParameters['reportType'] == null) {
            throw new runtime.RequiredError(
                'reportType',
                'Required parameter "reportType" was null or undefined when calling getGeneratedReportDownloadUrl().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['checkId'] != null) {
            queryParameters['check_id'] = requestParameters['checkId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/leads/{lead_id}/generated-reports/{report_type}/download-url`;
        urlPath = urlPath.replace('{lead_id}', encodeURIComponent(String(requestParameters['leadId'])));
        urlPath = urlPath.replace('{report_type}', encodeURIComponent(String(requestParameters['reportType'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Signs and returns a download URL for the existing document record without generating or regenerating anything. 404s if the report has not been generated yet.
     * Get a download URL for an already-generated report
     */
    async getGeneratedReportDownloadUrlRaw(requestParameters: GetGeneratedReportDownloadUrlRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GenerateReport200Response>> {
        const requestOptions = await this.getGeneratedReportDownloadUrlRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GenerateReport200ResponseFromJSON(jsonValue));
    }

    /**
     * Signs and returns a download URL for the existing document record without generating or regenerating anything. 404s if the report has not been generated yet.
     * Get a download URL for an already-generated report
     */
    async getGeneratedReportDownloadUrl(requestParameters: GetGeneratedReportDownloadUrlRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GenerateReport200Response> {
        const response = await this.getGeneratedReportDownloadUrlRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getPccDemographicsPrefill without sending the request
     */
    async getPccDemographicsPrefillRequestOpts(requestParameters: GetPccDemographicsPrefillRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['leadId'] == null) {
            throw new runtime.RequiredError(
                'leadId',
                'Required parameter "leadId" was null or undefined when calling getPccDemographicsPrefill().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/leads/{lead_id}/pcc/demographics-prefill`;
        urlPath = urlPath.replace('{lead_id}', encodeURIComponent(String(requestParameters['leadId'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Returns a ready-to-use object the demographics form can use as initial values. Backend merges AI-normalized lead info with the latest PCC patient record (when one exists). Users can still change any field.
     * Get pre-resolved PCC demographics prefill for a lead
     */
    async getPccDemographicsPrefillRaw(requestParameters: GetPccDemographicsPrefillRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetPccDemographicsPrefill200Response>> {
        const requestOptions = await this.getPccDemographicsPrefillRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetPccDemographicsPrefill200ResponseFromJSON(jsonValue));
    }

    /**
     * Returns a ready-to-use object the demographics form can use as initial values. Backend merges AI-normalized lead info with the latest PCC patient record (when one exists). Users can still change any field.
     * Get pre-resolved PCC demographics prefill for a lead
     */
    async getPccDemographicsPrefill(requestParameters: GetPccDemographicsPrefillRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetPccDemographicsPrefill200Response> {
        const response = await this.getPccDemographicsPrefillRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getPccPicklist without sending the request
     */
    async getPccPicklistRequestOpts(requestParameters: GetPccPicklistRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['leadId'] == null) {
            throw new runtime.RequiredError(
                'leadId',
                'Required parameter "leadId" was null or undefined when calling getPccPicklist().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/leads/{lead_id}/pcc/picklist`;
        urlPath = urlPath.replace('{lead_id}', encodeURIComponent(String(requestParameters['leadId'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Get PCC picklist options for a lead\'s facility
     */
    async getPccPicklistRaw(requestParameters: GetPccPicklistRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetPccPicklist200Response>> {
        const requestOptions = await this.getPccPicklistRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetPccPicklist200ResponseFromJSON(jsonValue));
    }

    /**
     * Get PCC picklist options for a lead\'s facility
     */
    async getPccPicklist(requestParameters: GetPccPicklistRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetPccPicklist200Response> {
        const response = await this.getPccPicklistRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for ignoreDuplicateCheckForLead without sending the request
     */
    async ignoreDuplicateCheckForLeadRequestOpts(requestParameters: IgnoreDuplicateCheckForLeadRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['leadId'] == null) {
            throw new runtime.RequiredError(
                'leadId',
                'Required parameter "leadId" was null or undefined when calling ignoreDuplicateCheckForLead().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/leads/{lead_id}/ignore-duplicate-check`;
        urlPath = urlPath.replace('{lead_id}', encodeURIComponent(String(requestParameters['leadId'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Ignore duplicate check for a screener lead by ID
     */
    async ignoreDuplicateCheckForLeadRaw(requestParameters: IgnoreDuplicateCheckForLeadRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreateLead201Response>> {
        const requestOptions = await this.ignoreDuplicateCheckForLeadRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CreateLead201ResponseFromJSON(jsonValue));
    }

    /**
     * Ignore duplicate check for a screener lead by ID
     */
    async ignoreDuplicateCheckForLead(requestParameters: IgnoreDuplicateCheckForLeadRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreateLead201Response> {
        const response = await this.ignoreDuplicateCheckForLeadRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for listAssignmentRules without sending the request
     */
    async listAssignmentRulesRequestOpts(): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/assignment-rules`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * List auto-allocation assignment rules
     */
    async listAssignmentRulesRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListAssignmentRules200Response>> {
        const requestOptions = await this.listAssignmentRulesRequestOpts();
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ListAssignmentRules200ResponseFromJSON(jsonValue));
    }

    /**
     * List auto-allocation assignment rules
     */
    async listAssignmentRules(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListAssignmentRules200Response> {
        const response = await this.listAssignmentRulesRaw(initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for listGeneratedReports without sending the request
     */
    async listGeneratedReportsRequestOpts(requestParameters: ListGeneratedReportsRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['leadId'] == null) {
            throw new runtime.RequiredError(
                'leadId',
                'Required parameter "leadId" was null or undefined when calling listGeneratedReports().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/leads/{lead_id}/generated-reports`;
        urlPath = urlPath.replace('{lead_id}', encodeURIComponent(String(requestParameters['leadId'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Returns the existing generated-document records for a lead without generating anything (no side effects).
     * List a screener lead\'s generated document records
     */
    async listGeneratedReportsRaw(requestParameters: ListGeneratedReportsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListGeneratedReports200Response>> {
        const requestOptions = await this.listGeneratedReportsRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ListGeneratedReports200ResponseFromJSON(jsonValue));
    }

    /**
     * Returns the existing generated-document records for a lead without generating anything (no side effects).
     * List a screener lead\'s generated document records
     */
    async listGeneratedReports(requestParameters: ListGeneratedReportsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListGeneratedReports200Response> {
        const response = await this.listGeneratedReportsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for patchPccDemographics without sending the request
     */
    async patchPccDemographicsRequestOpts(requestParameters: PatchPccDemographicsOperationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['leadId'] == null) {
            throw new runtime.RequiredError(
                'leadId',
                'Required parameter "leadId" was null or undefined when calling patchPccDemographics().'
            );
        }

        if (requestParameters['patchPccDemographicsRequest'] == null) {
            throw new runtime.RequiredError(
                'patchPccDemographicsRequest',
                'Required parameter "patchPccDemographicsRequest" was null or undefined when calling patchPccDemographics().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/leads/{lead_id}/pcc/demographics`;
        urlPath = urlPath.replace('{lead_id}', encodeURIComponent(String(requestParameters['leadId'])));

        return {
            path: urlPath,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: PatchPccDemographicsRequestToJSON(requestParameters['patchPccDemographicsRequest']),
        };
    }

    /**
     * Patch PCC patient demographics after acceptance
     */
    async patchPccDemographicsRaw(requestParameters: PatchPccDemographicsOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PatchPccDemographics200Response>> {
        const requestOptions = await this.patchPccDemographicsRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PatchPccDemographics200ResponseFromJSON(jsonValue));
    }

    /**
     * Patch PCC patient demographics after acceptance
     */
    async patchPccDemographics(requestParameters: PatchPccDemographicsOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PatchPccDemographics200Response> {
        const response = await this.patchPccDemographicsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for readmitToFacility without sending the request
     */
    async readmitToFacilityRequestOpts(requestParameters: ReadmitToFacilityOperationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['readmitToFacilityRequest'] == null) {
            throw new runtime.RequiredError(
                'readmitToFacilityRequest',
                'Required parameter "readmitToFacilityRequest" was null or undefined when calling readmitToFacility().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/leads/readmit-to-facility`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ReadmitToFacilityRequestToJSON(requestParameters['readmitToFacilityRequest']),
        };
    }

    /**
     * Readmit a hospitalized resident to a facility
     */
    async readmitToFacilityRaw(requestParameters: ReadmitToFacilityOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ReadmitToFacility200Response>> {
        const requestOptions = await this.readmitToFacilityRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ReadmitToFacility200ResponseFromJSON(jsonValue));
    }

    /**
     * Readmit a hospitalized resident to a facility
     */
    async readmitToFacility(requestParameters: ReadmitToFacilityOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ReadmitToFacility200Response> {
        const response = await this.readmitToFacilityRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for reorderAssignmentRules without sending the request
     */
    async reorderAssignmentRulesRequestOpts(requestParameters: ReorderAssignmentRulesOperationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['reorderAssignmentRulesRequest'] == null) {
            throw new runtime.RequiredError(
                'reorderAssignmentRulesRequest',
                'Required parameter "reorderAssignmentRulesRequest" was null or undefined when calling reorderAssignmentRules().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/assignment-rules/reorder`;

        return {
            path: urlPath,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: ReorderAssignmentRulesRequestToJSON(requestParameters['reorderAssignmentRulesRequest']),
        };
    }

    /**
     * Reorder auto-allocation assignment rules
     */
    async reorderAssignmentRulesRaw(requestParameters: ReorderAssignmentRulesOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListAssignmentRules200Response>> {
        const requestOptions = await this.reorderAssignmentRulesRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ListAssignmentRules200ResponseFromJSON(jsonValue));
    }

    /**
     * Reorder auto-allocation assignment rules
     */
    async reorderAssignmentRules(requestParameters: ReorderAssignmentRulesOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListAssignmentRules200Response> {
        const response = await this.reorderAssignmentRulesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for returnToFacility without sending the request
     */
    async returnToFacilityRequestOpts(requestParameters: ReturnToFacilityOperationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['leadId'] == null) {
            throw new runtime.RequiredError(
                'leadId',
                'Required parameter "leadId" was null or undefined when calling returnToFacility().'
            );
        }

        if (requestParameters['returnToFacilityRequest'] == null) {
            throw new runtime.RequiredError(
                'returnToFacilityRequest',
                'Required parameter "returnToFacilityRequest" was null or undefined when calling returnToFacility().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/leads/{lead_id}/return-to-facility`;
        urlPath = urlPath.replace('{lead_id}', encodeURIComponent(String(requestParameters['leadId'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ReturnToFacilityRequestToJSON(requestParameters['returnToFacilityRequest']),
        };
    }

    /**
     * Return an LOA resident to the facility
     */
    async returnToFacilityRaw(requestParameters: ReturnToFacilityOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreateLead201Response>> {
        const requestOptions = await this.returnToFacilityRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CreateLead201ResponseFromJSON(jsonValue));
    }

    /**
     * Return an LOA resident to the facility
     */
    async returnToFacility(requestParameters: ReturnToFacilityOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreateLead201Response> {
        const response = await this.returnToFacilityRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for revertAdmissionStatusById without sending the request
     */
    async revertAdmissionStatusByIdRequestOpts(requestParameters: RevertAdmissionStatusByIdRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['leadId'] == null) {
            throw new runtime.RequiredError(
                'leadId',
                'Required parameter "leadId" was null or undefined when calling revertAdmissionStatusById().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/leads/{lead_id}/admission-status/revert`;
        urlPath = urlPath.replace('{lead_id}', encodeURIComponent(String(requestParameters['leadId'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: RevertAdmissionStatusRequestToJSON(requestParameters['revertAdmissionStatusRequest']),
        };
    }

    /**
     * Revert the admission status to a previous one of a screener lead by ID
     */
    async revertAdmissionStatusByIdRaw(requestParameters: RevertAdmissionStatusByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreateLead201Response>> {
        const requestOptions = await this.revertAdmissionStatusByIdRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CreateLead201ResponseFromJSON(jsonValue));
    }

    /**
     * Revert the admission status to a previous one of a screener lead by ID
     */
    async revertAdmissionStatusById(requestParameters: RevertAdmissionStatusByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreateLead201Response> {
        const response = await this.revertAdmissionStatusByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for setLeadAssignments without sending the request
     */
    async setLeadAssignmentsRequestOpts(requestParameters: SetLeadAssignmentsOperationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['leadId'] == null) {
            throw new runtime.RequiredError(
                'leadId',
                'Required parameter "leadId" was null or undefined when calling setLeadAssignments().'
            );
        }

        if (requestParameters['setLeadAssignmentsRequest'] == null) {
            throw new runtime.RequiredError(
                'setLeadAssignmentsRequest',
                'Required parameter "setLeadAssignmentsRequest" was null or undefined when calling setLeadAssignments().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/leads/{lead_id}/assignments`;
        urlPath = urlPath.replace('{lead_id}', encodeURIComponent(String(requestParameters['leadId'])));

        return {
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: SetLeadAssignmentsRequestToJSON(requestParameters['setLeadAssignmentsRequest']),
        };
    }

    /**
     * Bulk-replace assignments for a referral (Owner + Liaisons) atomically
     */
    async setLeadAssignmentsRaw(requestParameters: SetLeadAssignmentsOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SetLeadAssignments200Response>> {
        const requestOptions = await this.setLeadAssignmentsRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SetLeadAssignments200ResponseFromJSON(jsonValue));
    }

    /**
     * Bulk-replace assignments for a referral (Owner + Liaisons) atomically
     */
    async setLeadAssignments(requestParameters: SetLeadAssignmentsOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SetLeadAssignments200Response> {
        const response = await this.setLeadAssignmentsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for syncLeadSOffenderRecordsById without sending the request
     */
    async syncLeadSOffenderRecordsByIdRequestOpts(requestParameters: SyncLeadSOffenderRecordsByIdOperationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['leadId'] == null) {
            throw new runtime.RequiredError(
                'leadId',
                'Required parameter "leadId" was null or undefined when calling syncLeadSOffenderRecordsById().'
            );
        }

        if (requestParameters['syncLeadSOffenderRecordsByIdRequest'] == null) {
            throw new runtime.RequiredError(
                'syncLeadSOffenderRecordsByIdRequest',
                'Required parameter "syncLeadSOffenderRecordsByIdRequest" was null or undefined when calling syncLeadSOffenderRecordsById().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/leads/{lead_id}/s-offender-records/sync`;
        urlPath = urlPath.replace('{lead_id}', encodeURIComponent(String(requestParameters['leadId'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SyncLeadSOffenderRecordsByIdRequestToJSON(requestParameters['syncLeadSOffenderRecordsByIdRequest']),
        };
    }

    /**
     * Trigger a screener lead s. offender sync by ID
     */
    async syncLeadSOffenderRecordsByIdRaw(requestParameters: SyncLeadSOffenderRecordsByIdOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FindSOffenderRecordsForLead200Response>> {
        const requestOptions = await this.syncLeadSOffenderRecordsByIdRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FindSOffenderRecordsForLead200ResponseFromJSON(jsonValue));
    }

    /**
     * Trigger a screener lead s. offender sync by ID
     */
    async syncLeadSOffenderRecordsById(requestParameters: SyncLeadSOffenderRecordsByIdOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FindSOffenderRecordsForLead200Response> {
        const response = await this.syncLeadSOffenderRecordsByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for unclaimLeadById without sending the request
     */
    async unclaimLeadByIdRequestOpts(requestParameters: UnclaimLeadByIdRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['leadId'] == null) {
            throw new runtime.RequiredError(
                'leadId',
                'Required parameter "leadId" was null or undefined when calling unclaimLeadById().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/leads/{lead_id}/unclaim`;
        urlPath = urlPath.replace('{lead_id}', encodeURIComponent(String(requestParameters['leadId'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Unclaim a screener lead by ID
     */
    async unclaimLeadByIdRaw(requestParameters: UnclaimLeadByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreateLead201Response>> {
        const requestOptions = await this.unclaimLeadByIdRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CreateLead201ResponseFromJSON(jsonValue));
    }

    /**
     * Unclaim a screener lead by ID
     */
    async unclaimLeadById(requestParameters: UnclaimLeadByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreateLead201Response> {
        const response = await this.unclaimLeadByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for updateAdmissionStatusById without sending the request
     */
    async updateAdmissionStatusByIdRequestOpts(requestParameters: UpdateAdmissionStatusByIdRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['leadId'] == null) {
            throw new runtime.RequiredError(
                'leadId',
                'Required parameter "leadId" was null or undefined when calling updateAdmissionStatusById().'
            );
        }

        if (requestParameters['updateAdmissionStatusRequest'] == null) {
            throw new runtime.RequiredError(
                'updateAdmissionStatusRequest',
                'Required parameter "updateAdmissionStatusRequest" was null or undefined when calling updateAdmissionStatusById().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/leads/{lead_id}/admission-status`;
        urlPath = urlPath.replace('{lead_id}', encodeURIComponent(String(requestParameters['leadId'])));

        return {
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateAdmissionStatusRequestToJSON(requestParameters['updateAdmissionStatusRequest']),
        };
    }

    /**
     * Update the admission status of a screener lead by ID
     */
    async updateAdmissionStatusByIdRaw(requestParameters: UpdateAdmissionStatusByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreateLead201Response>> {
        const requestOptions = await this.updateAdmissionStatusByIdRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CreateLead201ResponseFromJSON(jsonValue));
    }

    /**
     * Update the admission status of a screener lead by ID
     */
    async updateAdmissionStatusById(requestParameters: UpdateAdmissionStatusByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreateLead201Response> {
        const response = await this.updateAdmissionStatusByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for updateAssignmentRule without sending the request
     */
    async updateAssignmentRuleRequestOpts(requestParameters: UpdateAssignmentRuleOperationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['ruleId'] == null) {
            throw new runtime.RequiredError(
                'ruleId',
                'Required parameter "ruleId" was null or undefined when calling updateAssignmentRule().'
            );
        }

        if (requestParameters['updateAssignmentRuleRequest'] == null) {
            throw new runtime.RequiredError(
                'updateAssignmentRuleRequest',
                'Required parameter "updateAssignmentRuleRequest" was null or undefined when calling updateAssignmentRule().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/assignment-rules/{rule_id}`;
        urlPath = urlPath.replace('{rule_id}', encodeURIComponent(String(requestParameters['ruleId'])));

        return {
            path: urlPath,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateAssignmentRuleRequestToJSON(requestParameters['updateAssignmentRuleRequest']),
        };
    }

    /**
     * Update an auto-allocation assignment rule
     */
    async updateAssignmentRuleRaw(requestParameters: UpdateAssignmentRuleOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreateAssignmentRule201Response>> {
        const requestOptions = await this.updateAssignmentRuleRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CreateAssignmentRule201ResponseFromJSON(jsonValue));
    }

    /**
     * Update an auto-allocation assignment rule
     */
    async updateAssignmentRule(requestParameters: UpdateAssignmentRuleOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreateAssignmentRule201Response> {
        const response = await this.updateAssignmentRuleRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for updateDecisionOnLeadById without sending the request
     */
    async updateDecisionOnLeadByIdRequestOpts(requestParameters: UpdateDecisionOnLeadByIdRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['leadId'] == null) {
            throw new runtime.RequiredError(
                'leadId',
                'Required parameter "leadId" was null or undefined when calling updateDecisionOnLeadById().'
            );
        }

        if (requestParameters['updateLeadDecisionRequest'] == null) {
            throw new runtime.RequiredError(
                'updateLeadDecisionRequest',
                'Required parameter "updateLeadDecisionRequest" was null or undefined when calling updateDecisionOnLeadById().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/leads/{lead_id}/decision`;
        urlPath = urlPath.replace('{lead_id}', encodeURIComponent(String(requestParameters['leadId'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateLeadDecisionRequestToJSON(requestParameters['updateLeadDecisionRequest']),
        };
    }

    /**
     * Make a decision on a screener lead by ID
     */
    async updateDecisionOnLeadByIdRaw(requestParameters: UpdateDecisionOnLeadByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreateLead201Response>> {
        const requestOptions = await this.updateDecisionOnLeadByIdRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CreateLead201ResponseFromJSON(jsonValue));
    }

    /**
     * Make a decision on a screener lead by ID
     */
    async updateDecisionOnLeadById(requestParameters: UpdateDecisionOnLeadByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreateLead201Response> {
        const response = await this.updateDecisionOnLeadByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for updateIntegrationSettingsByFacilityId without sending the request
     */
    async updateIntegrationSettingsByFacilityIdRequestOpts(requestParameters: UpdateIntegrationSettingsByFacilityIdRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['facilityId'] == null) {
            throw new runtime.RequiredError(
                'facilityId',
                'Required parameter "facilityId" was null or undefined when calling updateIntegrationSettingsByFacilityId().'
            );
        }

        if (requestParameters['integrationSettings'] == null) {
            throw new runtime.RequiredError(
                'integrationSettings',
                'Required parameter "integrationSettings" was null or undefined when calling updateIntegrationSettingsByFacilityId().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/facilities/{facility_id}/integrations/settings`;
        urlPath = urlPath.replace('{facility_id}', encodeURIComponent(String(requestParameters['facilityId'])));

        return {
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: IntegrationSettingsToJSON(requestParameters['integrationSettings']),
        };
    }

    /**
     * Update screener integration settings for facility
     */
    async updateIntegrationSettingsByFacilityIdRaw(requestParameters: UpdateIntegrationSettingsByFacilityIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FindOneIntegrationSettingsByFacilityId200Response>> {
        const requestOptions = await this.updateIntegrationSettingsByFacilityIdRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FindOneIntegrationSettingsByFacilityId200ResponseFromJSON(jsonValue));
    }

    /**
     * Update screener integration settings for facility
     */
    async updateIntegrationSettingsByFacilityId(requestParameters: UpdateIntegrationSettingsByFacilityIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FindOneIntegrationSettingsByFacilityId200Response> {
        const response = await this.updateIntegrationSettingsByFacilityIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for updateLeadAssignment without sending the request
     */
    async updateLeadAssignmentRequestOpts(requestParameters: UpdateLeadAssignmentOperationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['leadId'] == null) {
            throw new runtime.RequiredError(
                'leadId',
                'Required parameter "leadId" was null or undefined when calling updateLeadAssignment().'
            );
        }

        if (requestParameters['assignmentId'] == null) {
            throw new runtime.RequiredError(
                'assignmentId',
                'Required parameter "assignmentId" was null or undefined when calling updateLeadAssignment().'
            );
        }

        if (requestParameters['updateLeadAssignmentRequest'] == null) {
            throw new runtime.RequiredError(
                'updateLeadAssignmentRequest',
                'Required parameter "updateLeadAssignmentRequest" was null or undefined when calling updateLeadAssignment().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/leads/{lead_id}/assignments/{assignment_id}`;
        urlPath = urlPath.replace('{lead_id}', encodeURIComponent(String(requestParameters['leadId'])));
        urlPath = urlPath.replace('{assignment_id}', encodeURIComponent(String(requestParameters['assignmentId'])));

        return {
            path: urlPath,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateLeadAssignmentRequestToJSON(requestParameters['updateLeadAssignmentRequest']),
        };
    }

    /**
     * Reassign an existing assignment to a different user
     */
    async updateLeadAssignmentRaw(requestParameters: UpdateLeadAssignmentOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreateLeadAssignment200Response>> {
        const requestOptions = await this.updateLeadAssignmentRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CreateLeadAssignment200ResponseFromJSON(jsonValue));
    }

    /**
     * Reassign an existing assignment to a different user
     */
    async updateLeadAssignment(requestParameters: UpdateLeadAssignmentOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreateLeadAssignment200Response> {
        const response = await this.updateLeadAssignmentRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for updateLeadById without sending the request
     */
    async updateLeadByIdRequestOpts(requestParameters: UpdateLeadByIdRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['leadId'] == null) {
            throw new runtime.RequiredError(
                'leadId',
                'Required parameter "leadId" was null or undefined when calling updateLeadById().'
            );
        }

        if (requestParameters['lead'] == null) {
            throw new runtime.RequiredError(
                'lead',
                'Required parameter "lead" was null or undefined when calling updateLeadById().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/leads/{lead_id}`;
        urlPath = urlPath.replace('{lead_id}', encodeURIComponent(String(requestParameters['leadId'])));

        return {
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: LeadToJSON(requestParameters['lead']),
        };
    }

    /**
     * Update a screener lead by ID
     */
    async updateLeadByIdRaw(requestParameters: UpdateLeadByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreateLead201Response>> {
        const requestOptions = await this.updateLeadByIdRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CreateLead201ResponseFromJSON(jsonValue));
    }

    /**
     * Update a screener lead by ID
     */
    async updateLeadById(requestParameters: UpdateLeadByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreateLead201Response> {
        const response = await this.updateLeadByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for updateLeadCommentById without sending the request
     */
    async updateLeadCommentByIdRequestOpts(requestParameters: UpdateLeadCommentByIdRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['commentId'] == null) {
            throw new runtime.RequiredError(
                'commentId',
                'Required parameter "commentId" was null or undefined when calling updateLeadCommentById().'
            );
        }

        if (requestParameters['leadComment'] == null) {
            throw new runtime.RequiredError(
                'leadComment',
                'Required parameter "leadComment" was null or undefined when calling updateLeadCommentById().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/lead-comments/{comment_id}`;
        urlPath = urlPath.replace('{comment_id}', encodeURIComponent(String(requestParameters['commentId'])));

        return {
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: LeadCommentToJSON(requestParameters['leadComment']),
        };
    }

    /**
     * Update a screener lead comment by ID
     */
    async updateLeadCommentByIdRaw(requestParameters: UpdateLeadCommentByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreateLeadComment201Response>> {
        const requestOptions = await this.updateLeadCommentByIdRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CreateLeadComment201ResponseFromJSON(jsonValue));
    }

    /**
     * Update a screener lead comment by ID
     */
    async updateLeadCommentById(requestParameters: UpdateLeadCommentByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreateLeadComment201Response> {
        const response = await this.updateLeadCommentByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for updateLeadSOffenderRecordById without sending the request
     */
    async updateLeadSOffenderRecordByIdRequestOpts(requestParameters: UpdateLeadSOffenderRecordByIdRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['sOffenderRecordId'] == null) {
            throw new runtime.RequiredError(
                'sOffenderRecordId',
                'Required parameter "sOffenderRecordId" was null or undefined when calling updateLeadSOffenderRecordById().'
            );
        }

        if (requestParameters['updateLeadSOffenderRecordRequest'] == null) {
            throw new runtime.RequiredError(
                'updateLeadSOffenderRecordRequest',
                'Required parameter "updateLeadSOffenderRecordRequest" was null or undefined when calling updateLeadSOffenderRecordById().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/s-offender-records/{s_offender_record_id}`;
        urlPath = urlPath.replace('{s_offender_record_id}', encodeURIComponent(String(requestParameters['sOffenderRecordId'])));

        return {
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateLeadSOffenderRecordRequestToJSON(requestParameters['updateLeadSOffenderRecordRequest']),
        };
    }

    /**
     * Update a lead s. offender record by ID
     */
    async updateLeadSOffenderRecordByIdRaw(requestParameters: UpdateLeadSOffenderRecordByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UpdateLeadSOffenderRecordById200Response>> {
        const requestOptions = await this.updateLeadSOffenderRecordByIdRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UpdateLeadSOffenderRecordById200ResponseFromJSON(jsonValue));
    }

    /**
     * Update a lead s. offender record by ID
     */
    async updateLeadSOffenderRecordById(requestParameters: UpdateLeadSOffenderRecordByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UpdateLeadSOffenderRecordById200Response> {
        const response = await this.updateLeadSOffenderRecordByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for updatePreviousStayById without sending the request
     */
    async updatePreviousStayByIdRequestOpts(requestParameters: UpdatePreviousStayByIdRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['leadId'] == null) {
            throw new runtime.RequiredError(
                'leadId',
                'Required parameter "leadId" was null or undefined when calling updatePreviousStayById().'
            );
        }

        if (requestParameters['updatePreviousStayRequest'] == null) {
            throw new runtime.RequiredError(
                'updatePreviousStayRequest',
                'Required parameter "updatePreviousStayRequest" was null or undefined when calling updatePreviousStayById().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/leads/{lead_id}/previous-stay`;
        urlPath = urlPath.replace('{lead_id}', encodeURIComponent(String(requestParameters['leadId'])));

        return {
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdatePreviousStayRequestToJSON(requestParameters['updatePreviousStayRequest']),
        };
    }

    /**
     * Update the previous stay in facility status of a screener lead by ID
     */
    async updatePreviousStayByIdRaw(requestParameters: UpdatePreviousStayByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreateLead201Response>> {
        const requestOptions = await this.updatePreviousStayByIdRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CreateLead201ResponseFromJSON(jsonValue));
    }

    /**
     * Update the previous stay in facility status of a screener lead by ID
     */
    async updatePreviousStayById(requestParameters: UpdatePreviousStayByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreateLead201Response> {
        const response = await this.updatePreviousStayByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for updateSourceById without sending the request
     */
    async updateSourceByIdRequestOpts(requestParameters: UpdateSourceByIdRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['sourceId'] == null) {
            throw new runtime.RequiredError(
                'sourceId',
                'Required parameter "sourceId" was null or undefined when calling updateSourceById().'
            );
        }

        if (requestParameters['source'] == null) {
            throw new runtime.RequiredError(
                'source',
                'Required parameter "source" was null or undefined when calling updateSourceById().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/sources/{source_id}`;
        urlPath = urlPath.replace('{source_id}', encodeURIComponent(String(requestParameters['sourceId'])));

        return {
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: SourceToJSON(requestParameters['source']),
        };
    }

    /**
     * Update a screener source by ID
     */
    async updateSourceByIdRaw(requestParameters: UpdateSourceByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreateSource201Response>> {
        const requestOptions = await this.updateSourceByIdRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CreateSource201ResponseFromJSON(jsonValue));
    }

    /**
     * Update a screener source by ID
     */
    async updateSourceById(requestParameters: UpdateSourceByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreateSource201Response> {
        const response = await this.updateSourceByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for updateSourceContactById without sending the request
     */
    async updateSourceContactByIdRequestOpts(requestParameters: UpdateSourceContactByIdRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['contactId'] == null) {
            throw new runtime.RequiredError(
                'contactId',
                'Required parameter "contactId" was null or undefined when calling updateSourceContactById().'
            );
        }

        if (requestParameters['sourceContact'] == null) {
            throw new runtime.RequiredError(
                'sourceContact',
                'Required parameter "sourceContact" was null or undefined when calling updateSourceContactById().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/source-contacts/{contact_id}`;
        urlPath = urlPath.replace('{contact_id}', encodeURIComponent(String(requestParameters['contactId'])));

        return {
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: SourceContactToJSON(requestParameters['sourceContact']),
        };
    }

    /**
     * Update a screener source contact by ID
     */
    async updateSourceContactByIdRaw(requestParameters: UpdateSourceContactByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreateSourceContact201Response>> {
        const requestOptions = await this.updateSourceContactByIdRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CreateSourceContact201ResponseFromJSON(jsonValue));
    }

    /**
     * Update a screener source contact by ID
     */
    async updateSourceContactById(requestParameters: UpdateSourceContactByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreateSourceContact201Response> {
        const response = await this.updateSourceContactByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for updateSpecialCriteriaById without sending the request
     */
    async updateSpecialCriteriaByIdRequestOpts(requestParameters: UpdateSpecialCriteriaByIdOperationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['criteriaId'] == null) {
            throw new runtime.RequiredError(
                'criteriaId',
                'Required parameter "criteriaId" was null or undefined when calling updateSpecialCriteriaById().'
            );
        }

        if (requestParameters['updateSpecialCriteriaByIdRequest'] == null) {
            throw new runtime.RequiredError(
                'updateSpecialCriteriaByIdRequest',
                'Required parameter "updateSpecialCriteriaByIdRequest" was null or undefined when calling updateSpecialCriteriaById().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/special-criteria/{criteria_id}`;
        urlPath = urlPath.replace('{criteria_id}', encodeURIComponent(String(requestParameters['criteriaId'])));

        return {
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateSpecialCriteriaByIdRequestToJSON(requestParameters['updateSpecialCriteriaByIdRequest']),
        };
    }

    /**
     * Update special criteria by ID
     */
    async updateSpecialCriteriaByIdRaw(requestParameters: UpdateSpecialCriteriaByIdOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UpdateSpecialCriteriaById200Response>> {
        const requestOptions = await this.updateSpecialCriteriaByIdRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UpdateSpecialCriteriaById200ResponseFromJSON(jsonValue));
    }

    /**
     * Update special criteria by ID
     */
    async updateSpecialCriteriaById(requestParameters: UpdateSpecialCriteriaByIdOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UpdateSpecialCriteriaById200Response> {
        const response = await this.updateSpecialCriteriaByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for uploadPccAdvancedPatientDetails without sending the request
     */
    async uploadPccAdvancedPatientDetailsRequestOpts(requestParameters: UploadPccAdvancedPatientDetailsRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['leadId'] == null) {
            throw new runtime.RequiredError(
                'leadId',
                'Required parameter "leadId" was null or undefined when calling uploadPccAdvancedPatientDetails().'
            );
        }

        if (requestParameters['pccAdvancedPatientDetails'] == null) {
            throw new runtime.RequiredError(
                'pccAdvancedPatientDetails',
                'Required parameter "pccAdvancedPatientDetails" was null or undefined when calling uploadPccAdvancedPatientDetails().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/leads/{lead_id}/pcc/patient/details/advanced`;
        urlPath = urlPath.replace('{lead_id}', encodeURIComponent(String(requestParameters['leadId'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: PccAdvancedPatientDetailsToJSON(requestParameters['pccAdvancedPatientDetails']),
        };
    }

    /**
     * Upload a PCC advanced patient\'s details
     */
    async uploadPccAdvancedPatientDetailsRaw(requestParameters: UploadPccAdvancedPatientDetailsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UploadPccAdvancedPatientDetails200Response>> {
        const requestOptions = await this.uploadPccAdvancedPatientDetailsRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UploadPccAdvancedPatientDetails200ResponseFromJSON(jsonValue));
    }

    /**
     * Upload a PCC advanced patient\'s details
     */
    async uploadPccAdvancedPatientDetails(requestParameters: UploadPccAdvancedPatientDetailsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UploadPccAdvancedPatientDetails200Response> {
        const response = await this.uploadPccAdvancedPatientDetailsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for uploadPccPatientDetails without sending the request
     */
    async uploadPccPatientDetailsRequestOpts(requestParameters: UploadPccPatientDetailsOperationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['leadId'] == null) {
            throw new runtime.RequiredError(
                'leadId',
                'Required parameter "leadId" was null or undefined when calling uploadPccPatientDetails().'
            );
        }

        if (requestParameters['uploadPccPatientDetailsRequest'] == null) {
            throw new runtime.RequiredError(
                'uploadPccPatientDetailsRequest',
                'Required parameter "uploadPccPatientDetailsRequest" was null or undefined when calling uploadPccPatientDetails().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/leads/{lead_id}/pcc/patient/details`;
        urlPath = urlPath.replace('{lead_id}', encodeURIComponent(String(requestParameters['leadId'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: UploadPccPatientDetailsRequestToJSON(requestParameters['uploadPccPatientDetailsRequest']),
        };
    }

    /**
     * Upload a PCC patient\'s details
     */
    async uploadPccPatientDetailsRaw(requestParameters: UploadPccPatientDetailsOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UploadPccPatientDetails200Response>> {
        const requestOptions = await this.uploadPccPatientDetailsRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UploadPccPatientDetails200ResponseFromJSON(jsonValue));
    }

    /**
     * Upload a PCC patient\'s details
     */
    async uploadPccPatientDetails(requestParameters: UploadPccPatientDetailsOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UploadPccPatientDetails200Response> {
        const response = await this.uploadPccPatientDetailsRaw(requestParameters, initOverrides);
        return await response.value();
    }

}

/**
 * @export
 */
export const FindAllLeadsReviewStageAcceptSourceEnum = {
    Automated: 'automated',
    Manual: 'manual',
} as const;
export type FindAllLeadsReviewStageAcceptSourceEnum = typeof FindAllLeadsReviewStageAcceptSourceEnum[keyof typeof FindAllLeadsReviewStageAcceptSourceEnum];
